
var Rive = (() => {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
  
  return (
function(moduleArg = {}) {

var n = moduleArg, aa, ba;
n.ready = new Promise((a, b) => {
  aa = a;
  ba = b;
});
function ca() {
  function a(g) {
    const m = d;
    c = b = 0;
    d = new Map();
    m.forEach(p => {
      try {
        p(g);
      } catch (l) {
        console.error(l);
      }
    });
    this.ib();
    e && e.Kb();
  }
  let b = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(g) {
    b || (b = requestAnimationFrame(a.bind(this)));
    const m = ++c;
    d.set(m, g);
    return m;
  };
  this.cancelAnimationFrame = function(g) {
    d.delete(g);
    b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
  };
  this.Ib = function(g) {
    f && (document.body.remove(f), f = null);
    g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(m) {
      f.innerHTML = "RIVE FPS " + m.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let m = 0, p = 0;
      this.Kb = function() {
        var l = performance.now();
        p ? (++m, l -= p, 1000 < l && (g(1000 * m / l), m = p = 0)) : (p = l, m = 0);
      };
    }();
  };
  this.ib = function() {
  };
}
function da() {
  console.assert(!0);
  const a = new Map();
  let b = -Infinity;
  this.push = function(c) {
    c = c + 255 >> 8;
    a.has(c) && clearTimeout(a.get(c));
    a.set(c, setTimeout(function() {
      a.delete(c);
      0 == a.length ? b = -Infinity : c == b && (b = Math.max(...a.keys()), console.assert(b < c));
    }, 1000));
    b = Math.max(c, b);
    return b << 8;
  };
}
const ea = n.onRuntimeInitialized;
n.onRuntimeInitialized = function() {
  ea && ea();
  let a = n.decodeAudio;
  n.decodeAudio = function(e, f) {
    e = a(e);
    f(e);
  };
  let b = n.decodeFont;
  n.decodeFont = function(e, f) {
    e = b(e);
    f(e);
  };
  const c = n.FileAssetLoader;
  n.ptrToAsset = e => {
    let f = n.ptrToFileAsset(e);
    return f.isImage ? n.ptrToImageAsset(e) : f.isFont ? n.ptrToFontAsset(e) : f.isAudio ? n.ptrToAudioAsset(e) : f;
  };
  n.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {__construct:function({loadContents:e}) {
    this.__parent.__construct.call(this);
    this.zb = e;
  }, loadContents:function(e, f) {
    e = n.ptrToAsset(e);
    return this.zb(e, f);
  },});
  n.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(e) {
    let f = n.ptrToAsset(e);
    e = f.cdnUuid;
    if ("" === e) {
      return !1;
    }
    (function(g, m) {
      var p = new XMLHttpRequest();
      p.responseType = "arraybuffer";
      p.onreadystatechange = function() {
        4 == p.readyState && 200 == p.status && m(p);
      };
      p.open("GET", g, !0);
      p.send(null);
    })(f.cdnBaseUrl + "/" + e, g => {
      f.decode(new Uint8Array(g.response));
    });
    return !0;
  },});
  n.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.eb = [];
  }, addLoader:function(e) {
    this.eb.push(e);
  }, loadContents:function(e, f) {
    for (let g of this.eb) {
      if (g.loadContents(e, f)) {
        return !0;
      }
    }
    return !1;
  },});
  let d = n.computeAlignment;
  n.computeAlignment = function(e, f, g, m, p = 1.0) {
    return d.call(this, e, f, g, m, p);
  };
};
const fa = n.onRuntimeInitialized;
n.onRuntimeInitialized = function() {
  function a(k) {
    this.F = k;
    this.xb = k.getContext("2d");
    this.Bb = d;
    this.S = [];
    this.la = 0;
    this.clear = function() {
      console.assert(0 == this.la);
      this.S = [];
      e.delete(this);
    };
    this.save = function() {
      ++this.la;
      this.S.push(d.save.bind(d));
    };
    this.restore = function() {
      0 < this.la && (this.S.push(d.restore.bind(d)), --this.la);
    };
    this.transform = function(q) {
      this.S.push(d.transform.bind(d, q));
    };
    this.align = function(q, v, y, B, D = 1.0) {
      this.S.push(d.align.bind(d, q, v, y, B, D));
    };
    this.flush = function() {
      console.assert(0 == this.la);
      e.add(this);
      d.Ja || c();
    };
  }
  function b(k, q = !1) {
    var v = {alpha:!0, depth:q, stencil:q, antialias:q, premultipliedAlpha:!0, preserveDrawingBuffer:0, preferLowPowerToHighPerformance:0, failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:!1, explicitSwapControl:0, renderViaOffscreenBackBuffer:0,};
    q = k.getContext("webgl2", v);
    if (!q) {
      return null;
    }
    var y = ha(r), B = {handle:y, attributes:v, version:v.Cc, H:q};
    q.canvas && (q.canvas.nc = B);
    r[y] = B;
    ("undefined" == typeof v.Hb || v.Hb) && ia(B);
    ja(y);
    v = f(k.width, k.height);
    v.yb = y;
    v.F = k;
    v.Ua = k.width;
    v.Ta = k.height;
    v.ka = q;
    return v;
  }
  function c() {
    if (d) {
      var k = d.Ab, q = 0, v = 0, y = 0, B = Array(e.size), D = 0;
      for (var E of e) {
        E.ea = Math.min(E.F.width, k), E.da = Math.min(E.F.height, k), E.Ia = E.da * E.ea, q = Math.max(q, E.ea), v = Math.max(v, E.da), y += E.Ia, B[D++] = E;
      }
      e.clear();
      if (!(0 >= y)) {
        q = 1 << (0 >= q ? 0 : 32 - Math.clz32(q - 1));
        for (v = 1 << (0 >= v ? 0 : 32 - Math.clz32(v - 1)); v * q < y;) {
          q <= v ? q *= 2 : v *= 2;
        }
        q = Math.min(q, k);
        q = Math.min(v, k);
        B.sort((Z, rb) => rb.Ia - Z.Ia);
        y = new n.DynamicRectanizer(k);
        for (E = 0; E < B.length;) {
          y.reset(q, v);
          for (D = E; D < B.length; ++D) {
            var H = B[D], F = y.addRect(H.ea, H.da);
            if (0 > F) {
              console.assert(D > E);
              break;
            }
            H.ra = F & 65535;
            H.sa = F >> 16;
          }
          H = m.push(y.drawWidth());
          F = p.push(y.drawHeight());
          console.assert(H >= y.drawWidth());
          console.assert(F >= y.drawHeight());
          console.assert(H <= k);
          console.assert(F <= k);
          d.F.width != H && (d.F.width = H);
          d.F.height != F && (d.F.height = F);
          d.clear();
          for (H = E; H < D; ++H) {
            F = B[H];
            d.saveClipRect(F.ra, F.sa, F.ra + F.ea, F.sa + F.da);
            let Z = new n.Mat2D();
            Z.xx = F.ea / F.F.width;
            Z.yy = F.da / F.F.height;
            Z.xy = Z.yx = 0;
            Z.tx = F.ra;
            Z.ty = F.sa;
            d.transform(Z);
            for (const rb of F.S) {
              rb();
            }
            d.restoreClipRect();
            F.S = [];
          }
          for (d.flush(); E < D; ++E) {
            H = B[E], F = H.xb, F.globalCompositeOperation = "copy", F.drawImage(d.F, H.ra, H.sa, H.ea, H.da, 0, 0, H.F.width, H.F.height);
          }
          E = D;
        }
      }
    }
  }
  fa && fa();
  let d = null;
  const e = new Set(), f = n.makeRenderer;
  n.makeRenderer = function(k, q) {
    if (!d) {
      function v(y) {
        const B = document.createElement("canvas");
        B.width = 1;
        B.height = 1;
        d = b(B, y);
        d.Ja = !!d.ka.getExtension("WEBGL_shader_pixel_local_storage");
        d.Ab = Math.min(d.ka.getParameter(d.ka.MAX_RENDERBUFFER_SIZE), d.ka.getParameter(d.ka.MAX_TEXTURE_SIZE));
        return d;
      }
      d = v(!0);
      d.Ja && (d = v(!1));
    }
    return q ? new a(k) : b(k, !d.Ja);
  };
  const g = n.Artboard.prototype.draw;
  n.Artboard.prototype.draw = function(k) {
    k.S ? k.S.push(g.bind(this, k.Bb)) : g.call(this, k);
  };
  const m = new da(), p = new da(), l = new ca();
  n.requestAnimationFrame = l.requestAnimationFrame.bind(l);
  n.cancelAnimationFrame = l.cancelAnimationFrame.bind(l);
  n.enableFPSCounter = l.Ib.bind(l);
  l.ib = c;
  n.resolveAnimationFrame = c;
  let t = n.load;
  n.load = function(k, q, v = !0) {
    const y = new n.FallbackFileAssetLoader();
    void 0 !== q && y.addLoader(q);
    v && (q = new n.CDNFileAssetLoader(), y.addLoader(q));
    return Promise.resolve(t(k, y));
  };
  const u = n.WebGL2Renderer.prototype.clear;
  n.WebGL2Renderer.prototype.clear = function() {
    ja(this.yb);
    const k = this.F;
    if (this.Ua != k.width || this.Ta != k.height) {
      this.resize(k.width, k.height), this.Ua = k.width, this.Ta = k.height;
    }
    u.call(this);
  };
  n.decodeImage = function(k, q) {
    k = n.decodeWebGL2Image(k);
    q(k);
  };
  let x = n.Renderer.prototype.align;
  n.Renderer.prototype.align = function(k, q, v, y, B = 1.0) {
    x.call(this, k, q, v, y, B);
  };
};
var ka = Object.assign({}, n), la = "./this.program", ma = "object" == typeof window, na = "function" == typeof importScripts, w = "", oa, pa;
if (ma || na) {
  na ? w = self.location.href : "undefined" != typeof document && document.currentScript && (w = document.currentScript.src), _scriptDir && (w = _scriptDir), 0 !== w.indexOf("blob:") ? w = w.substr(0, w.replace(/[?#].*/, "").lastIndexOf("/") + 1) : w = "", na && (pa = a => {
    var b = new XMLHttpRequest();
    b.open("GET", a, !1);
    b.responseType = "arraybuffer";
    b.send(null);
    return new Uint8Array(b.response);
  }), oa = (a, b, c) => {
    var d = new XMLHttpRequest();
    d.open("GET", a, !0);
    d.responseType = "arraybuffer";
    d.onload = () => {
      200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
    };
    d.onerror = c;
    d.send(null);
  };
}
var qa = n.print || console.log.bind(console), ra = n.printErr || console.error.bind(console);
Object.assign(n, ka);
ka = null;
n.thisProgram && (la = n.thisProgram);
var sa;
n.wasmBinary && (sa = n.wasmBinary);
var noExitRuntime = n.noExitRuntime || !0;
"object" != typeof WebAssembly && ta("no native wasm support detected");
var ua, z, va = !1, A, C, G, wa, I, J, xa, ya;
function za() {
  var a = ua.buffer;
  n.HEAP8 = A = new Int8Array(a);
  n.HEAP16 = G = new Int16Array(a);
  n.HEAP32 = I = new Int32Array(a);
  n.HEAPU8 = C = new Uint8Array(a);
  n.HEAPU16 = wa = new Uint16Array(a);
  n.HEAPU32 = J = new Uint32Array(a);
  n.HEAPF32 = xa = new Float32Array(a);
  n.HEAPF64 = ya = new Float64Array(a);
}
var Aa, Ba = [], Ca = [], Da = [];
function Ea() {
  var a = n.preRun.shift();
  Ba.unshift(a);
}
var Fa = 0, Ga = null, Ha = null;
function ta(a) {
  if (n.onAbort) {
    n.onAbort(a);
  }
  a = "Aborted(" + a + ")";
  ra(a);
  va = !0;
  a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
  ba(a);
  throw a;
}
function Ia(a) {
  return a.startsWith("data:application/octet-stream;base64,");
}
var Ja;
Ja = "webgl2_advanced.wasm";
if (!Ia(Ja)) {
  var Ka = Ja;
  Ja = n.locateFile ? n.locateFile(Ka, w) : w + Ka;
}
function La(a) {
  if (a == Ja && sa) {
    return new Uint8Array(sa);
  }
  if (pa) {
    return pa(a);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Ma(a) {
  if (!sa && (ma || na)) {
    if ("function" == typeof fetch && !a.startsWith("file://")) {
      return fetch(a, {credentials:"same-origin"}).then(b => {
        if (!b.ok) {
          throw "failed to load wasm binary file at '" + a + "'";
        }
        return b.arrayBuffer();
      }).catch(() => La(a));
    }
    if (oa) {
      return new Promise((b, c) => {
        oa(a, d => b(new Uint8Array(d)), c);
      });
    }
  }
  return Promise.resolve().then(() => La(a));
}
function Na(a, b, c) {
  return Ma(a).then(d => WebAssembly.instantiate(d, b)).then(d => d).then(c, d => {
    ra("failed to asynchronously prepare wasm: " + d);
    ta(d);
  });
}
function Oa(a, b) {
  var c = Ja;
  return sa || "function" != typeof WebAssembly.instantiateStreaming || Ia(c) || c.startsWith("file://") || "function" != typeof fetch ? Na(c, a, b) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
    ra("wasm streaming compile failed: " + e);
    ra("falling back to ArrayBuffer instantiation");
    return Na(c, a, b);
  }));
}
var Pa, Qa, Ua = {485221:(a, b, c, d, e) => {
  if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) {
    return 0;
  }
  if ("undefined" === typeof window.h) {
    window.h = {Da:0};
    window.h.I = {};
    window.h.I.Ba = a;
    window.h.I.capture = b;
    window.h.I.La = c;
    window.h.ha = {};
    window.h.ha.stopped = d;
    window.h.ha.rb = e;
    let f = window.h;
    f.C = [];
    f.lc = function(g) {
      for (var m = 0; m < f.C.length; ++m) {
        if (null == f.C[m]) {
          return f.C[m] = g, m;
        }
      }
      f.C.push(g);
      return f.C.length - 1;
    };
    f.wb = function(g) {
      for (f.C[g] = null; 0 < f.C.length;) {
        if (null == f.C[f.C.length - 1]) {
          f.C.pop();
        } else {
          break;
        }
      }
    };
    f.Nc = function(g) {
      for (var m = 0; m < f.C.length; ++m) {
        if (f.C[m] == g) {
          return f.wb(m);
        }
      }
    };
    f.va = function(g) {
      return f.C[g];
    };
    f.vb = ["touchend", "click"];
    f.unlock = function() {
      for (var g = 0; g < f.C.length; ++g) {
        var m = f.C[g];
        null != m && null != m.J && m.state === f.ha.rb && m.J.resume().then(() => {
          Ra(m.jb);
        }, p => {
          console.error("Failed to resume audiocontext", p);
        });
      }
      f.vb.map(function(p) {
        document.removeEventListener(p, f.unlock, !0);
      });
    };
    f.vb.map(function(g) {
      document.addEventListener(g, f.unlock, !0);
    });
  }
  window.h.Da += 1;
  return 1;
}, 487399:() => {
  "undefined" !== typeof window.h && (--window.h.Da, 0 === window.h.Da && delete window.h);
}, 487563:() => void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia, 487667:() => {
  try {
    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
    a.close();
    return b;
  } catch (c) {
    return 0;
  }
}, 487838:(a, b, c, d, e, f) => {
  if ("undefined" === typeof window.h) {
    return -1;
  }
  var g = {}, m = {};
  a == window.h.I.Ba && 0 != c && (m.sampleRate = c);
  g.J = new (window.AudioContext || window.webkitAudioContext)(m);
  g.J.suspend();
  g.state = window.h.ha.stopped;
  c = 0;
  a != window.h.I.Ba && (c = b);
  g.Y = g.J.createScriptProcessor(d, c, b);
  g.Y.onaudioprocess = function(p) {
    if (null == g.wa || 0 == g.wa.length) {
      g.wa = new Float32Array(xa.buffer, e, d * b);
    }
    if (a == window.h.I.capture || a == window.h.I.La) {
      for (var l = 0; l < b; l += 1) {
        for (var t = p.inputBuffer.getChannelData(l), u = g.wa, x = 0; x < d; x += 1) {
          u[x * b + l] = t[x];
        }
      }
      Sa(f, d, e);
    }
    if (a == window.h.I.Ba || a == window.h.I.La) {
      for (Ta(f, d, e), l = 0; l < p.outputBuffer.numberOfChannels; ++l) {
        for (t = p.outputBuffer.getChannelData(l), u = g.wa, x = 0; x < d; x += 1) {
          t[x] = u[x * b + l];
        }
      }
    } else {
      for (l = 0; l < p.outputBuffer.numberOfChannels; ++l) {
        p.outputBuffer.getChannelData(l).fill(0.0);
      }
    }
  };
  a != window.h.I.capture && a != window.h.I.La || navigator.mediaDevices.getUserMedia({audio:!0, video:!1}).then(function(p) {
    g.Ea = g.J.createMediaStreamSource(p);
    g.Ea.connect(g.Y);
    g.Y.connect(g.J.destination);
  }).catch(function(p) {
    console.log("Failed to get user media: " + p);
  });
  a == window.h.I.Ba && g.Y.connect(g.J.destination);
  g.jb = f;
  return window.h.lc(g);
}, 490715:a => window.h.va(a).J.sampleRate, 490788:a => {
  a = window.h.va(a);
  void 0 !== a.Y && (a.Y.onaudioprocess = function() {
  }, a.Y.disconnect(), a.Y = void 0);
  void 0 !== a.Ea && (a.Ea.disconnect(), a.Ea = void 0);
  a.J.close();
  a.J = void 0;
  a.jb = void 0;
}, 491188:a => {
  window.h.wb(a);
}, 491238:a => {
  a = window.h.va(a);
  a.J.resume();
  a.state = window.h.ha.rb;
}, 491377:a => {
  a = window.h.va(a);
  a.J.suspend();
  a.state = window.h.ha.stopped;
}}, Va = a => {
  for (; 0 < a.length;) {
    a.shift()(n);
  }
}, Wa = (a, b) => {
  for (var c = 0, d = a.length - 1; 0 <= d; d--) {
    var e = a[d];
    "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
  }
  if (b) {
    for (; c; c--) {
      a.unshift("..");
    }
  }
  return a;
}, Xa = a => {
  var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
  (a = Wa(a.split("/").filter(d => !!d), !b).join("/")) || b || (a = ".");
  a && c && (a += "/");
  return (b ? "/" : "") + a;
}, Ya = a => {
  var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
  a = b[0];
  b = b[1];
  if (!a && !b) {
    return ".";
  }
  b && (b = b.substr(0, b.length - 1));
  return a + b;
}, Za = a => {
  if ("/" === a) {
    return "/";
  }
  a = Xa(a);
  a = a.replace(/\/$/, "");
  var b = a.lastIndexOf("/");
  return -1 === b ? a : a.substr(b + 1);
}, $a = () => {
  if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) {
    return a => crypto.getRandomValues(a);
  }
  ta("initRandomDevice");
}, ab = a => (ab = $a())(a);
function bb() {
  for (var a = "", b = !1, c = arguments.length - 1; -1 <= c && !b; c--) {
    b = 0 <= c ? arguments[c] : "/";
    if ("string" != typeof b) {
      throw new TypeError("Arguments to path.resolve must be strings");
    }
    if (!b) {
      return "";
    }
    a = b + "/" + a;
    b = "/" === b.charAt(0);
  }
  a = Wa(a.split("/").filter(d => !!d), !b).join("/");
  return (b ? "/" : "") + a || ".";
}
var cb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, K = (a, b, c) => {
  var d = b + c;
  for (c = b; a[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - b && a.buffer && cb) {
    return cb.decode(a.subarray(b, c));
  }
  for (d = ""; b < c;) {
    var e = a[b++];
    if (e & 128) {
      var f = a[b++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var g = a[b++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, db = [], eb = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
  }
  return b;
}, fb = (a, b, c, d) => {
  if (!(0 < d)) {
    return 0;
  }
  var e = c;
  d = c + d - 1;
  for (var f = 0; f < a.length; ++f) {
    var g = a.charCodeAt(f);
    if (55296 <= g && 57343 >= g) {
      var m = a.charCodeAt(++f);
      g = 65536 + ((g & 1023) << 10) | m & 1023;
    }
    if (127 >= g) {
      if (c >= d) {
        break;
      }
      b[c++] = g;
    } else {
      if (2047 >= g) {
        if (c + 1 >= d) {
          break;
        }
        b[c++] = 192 | g >> 6;
      } else {
        if (65535 >= g) {
          if (c + 2 >= d) {
            break;
          }
          b[c++] = 224 | g >> 12;
        } else {
          if (c + 3 >= d) {
            break;
          }
          b[c++] = 240 | g >> 18;
          b[c++] = 128 | g >> 12 & 63;
        }
        b[c++] = 128 | g >> 6 & 63;
      }
      b[c++] = 128 | g & 63;
    }
  }
  b[c] = 0;
  return c - e;
};
function gb(a, b) {
  var c = Array(eb(a) + 1);
  a = fb(a, c, 0, c.length);
  b && (c.length = a);
  return c;
}
var hb = [];
function ib(a, b) {
  hb[a] = {input:[], D:[], U:b};
  jb(a, kb);
}
var kb = {open:function(a) {
  var b = hb[a.node.Ca];
  if (!b) {
    throw new L(43);
  }
  a.s = b;
  a.seekable = !1;
}, close:function(a) {
  a.s.U.ua(a.s);
}, ua:function(a) {
  a.s.U.ua(a.s);
}, read:function(a, b, c, d) {
  if (!a.s || !a.s.U.cb) {
    throw new L(60);
  }
  for (var e = 0, f = 0; f < d; f++) {
    try {
      var g = a.s.U.cb(a.s);
    } catch (m) {
      throw new L(29);
    }
    if (void 0 === g && 0 === e) {
      throw new L(6);
    }
    if (null === g || void 0 === g) {
      break;
    }
    e++;
    b[c + f] = g;
  }
  e && (a.node.timestamp = Date.now());
  return e;
}, write:function(a, b, c, d) {
  if (!a.s || !a.s.U.Oa) {
    throw new L(60);
  }
  try {
    for (var e = 0; e < d; e++) {
      a.s.U.Oa(a.s, b[c + e]);
    }
  } catch (f) {
    throw new L(29);
  }
  d && (a.node.timestamp = Date.now());
  return e;
},}, lb = {cb:function() {
  a: {
    if (!db.length) {
      var a = null;
      "undefined" != typeof window && "function" == typeof window.prompt ? (a = window.prompt("Input: "), null !== a && (a += "\n")) : "function" == typeof readline && (a = readline(), null !== a && (a += "\n"));
      if (!a) {
        a = null;
        break a;
      }
      db = gb(a, !0);
    }
    a = db.shift();
  }
  return a;
}, Oa:function(a, b) {
  null === b || 10 === b ? (qa(K(a.D, 0)), a.D = []) : 0 != b && a.D.push(b);
}, ua:function(a) {
  a.D && 0 < a.D.length && (qa(K(a.D, 0)), a.D = []);
}, Ub:function() {
  return {sc:25856, uc:5, rc:191, tc:35387, qc:[3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]};
}, Vb:function() {
  return 0;
}, Wb:function() {
  return [24, 80];
},}, mb = {Oa:function(a, b) {
  null === b || 10 === b ? (ra(K(a.D, 0)), a.D = []) : 0 != b && a.D.push(b);
}, ua:function(a) {
  a.D && 0 < a.D.length && (ra(K(a.D, 0)), a.D = []);
},};
function nb(a, b) {
  var c = a.j ? a.j.length : 0;
  c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.v && a.j.set(c.subarray(0, a.v), 0));
}
var M = {O:null, T() {
  return M.createNode(null, "/", 16895, 0);
}, createNode(a, b, c, d) {
  if (24576 === (c & 61440) || 4096 === (c & 61440)) {
    throw new L(63);
  }
  M.O || (M.O = {dir:{node:{X:M.l.X, P:M.l.P, ma:M.l.ma, za:M.l.za, pb:M.l.pb, ub:M.l.ub, qb:M.l.qb, nb:M.l.nb, Fa:M.l.Fa}, stream:{aa:M.m.aa}}, file:{node:{X:M.l.X, P:M.l.P}, stream:{aa:M.m.aa, read:M.m.read, write:M.m.write, ta:M.m.ta, fb:M.m.fb, hb:M.m.hb}}, link:{node:{X:M.l.X, P:M.l.P, na:M.l.na}, stream:{}}, Va:{node:{X:M.l.X, P:M.l.P}, stream:ob}});
  c = pb(a, b, c, d);
  16384 === (c.mode & 61440) ? (c.l = M.O.dir.node, c.m = M.O.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.l = M.O.file.node, c.m = M.O.file.stream, c.v = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.l = M.O.link.node, c.m = M.O.link.stream) : 8192 === (c.mode & 61440) && (c.l = M.O.Va.node, c.m = M.O.Va.stream);
  c.timestamp = Date.now();
  a && (a.j[b] = c, a.timestamp = c.timestamp);
  return c;
}, zc(a) {
  return a.j ? a.j.subarray ? a.j.subarray(0, a.v) : new Uint8Array(a.j) : new Uint8Array(0);
}, l:{X(a) {
  var b = {};
  b.xc = 8192 === (a.mode & 61440) ? a.id : 1;
  b.Bc = a.id;
  b.mode = a.mode;
  b.Jc = 1;
  b.uid = 0;
  b.Ac = 0;
  b.Ca = a.Ca;
  16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
  b.oc = new Date(a.timestamp);
  b.Hc = new Date(a.timestamp);
  b.vc = new Date(a.timestamp);
  b.Cb = 4096;
  b.pc = Math.ceil(b.size / b.Cb);
  return b;
}, P(a, b) {
  void 0 !== b.mode && (a.mode = b.mode);
  void 0 !== b.timestamp && (a.timestamp = b.timestamp);
  if (void 0 !== b.size && (b = b.size, a.v != b)) {
    if (0 == b) {
      a.j = null, a.v = 0;
    } else {
      var c = a.j;
      a.j = new Uint8Array(b);
      c && a.j.set(c.subarray(0, Math.min(b, a.v)));
      a.v = b;
    }
  }
}, ma() {
  throw qb[44];
}, za(a, b, c, d) {
  return M.createNode(a, b, c, d);
}, pb(a, b, c) {
  if (16384 === (a.mode & 61440)) {
    try {
      var d = sb(b, c);
    } catch (f) {
    }
    if (d) {
      for (var e in d.j) {
        throw new L(55);
      }
    }
  }
  delete a.parent.j[a.name];
  a.parent.timestamp = Date.now();
  a.name = c;
  b.j[c] = a;
  b.timestamp = a.parent.timestamp;
  a.parent = b;
}, ub(a, b) {
  delete a.j[b];
  a.timestamp = Date.now();
}, qb(a, b) {
  var c = sb(a, b), d;
  for (d in c.j) {
    throw new L(55);
  }
  delete a.j[b];
  a.timestamp = Date.now();
}, nb(a) {
  var b = [".", ".."], c;
  for (c in a.j) {
    a.j.hasOwnProperty(c) && b.push(c);
  }
  return b;
}, Fa(a, b, c) {
  a = M.createNode(a, b, 41471, 0);
  a.link = c;
  return a;
}, na(a) {
  if (40960 !== (a.mode & 61440)) {
    throw new L(28);
  }
  return a.link;
},}, m:{read(a, b, c, d, e) {
  var f = a.node.j;
  if (e >= a.node.v) {
    return 0;
  }
  a = Math.min(a.node.v - e, d);
  if (8 < a && f.subarray) {
    b.set(f.subarray(e, e + a), c);
  } else {
    for (d = 0; d < a; d++) {
      b[c + d] = f[e + d];
    }
  }
  return a;
}, write(a, b, c, d, e, f) {
  b.buffer === A.buffer && (f = !1);
  if (!d) {
    return 0;
  }
  a = a.node;
  a.timestamp = Date.now();
  if (b.subarray && (!a.j || a.j.subarray)) {
    if (f) {
      return a.j = b.subarray(c, c + d), a.v = d;
    }
    if (0 === a.v && 0 === e) {
      return a.j = b.slice(c, c + d), a.v = d;
    }
    if (e + d <= a.v) {
      return a.j.set(b.subarray(c, c + d), e), d;
    }
  }
  nb(a, e + d);
  if (a.j.subarray && b.subarray) {
    a.j.set(b.subarray(c, c + d), e);
  } else {
    for (f = 0; f < d; f++) {
      a.j[e + f] = b[c + f];
    }
  }
  a.v = Math.max(a.v, e + d);
  return d;
}, aa(a, b, c) {
  1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
  if (0 > b) {
    throw new L(28);
  }
  return b;
}, ta(a, b, c) {
  nb(a.node, b + c);
  a.node.v = Math.max(a.node.v, b + c);
}, fb(a, b, c, d, e) {
  if (32768 !== (a.node.mode & 61440)) {
    throw new L(43);
  }
  a = a.node.j;
  if (e & 2 || a.buffer !== A.buffer) {
    if (0 < c || c + b < a.length) {
      a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
    }
    c = !0;
    ta();
    b = void 0;
    if (!b) {
      throw new L(48);
    }
    A.set(a, b);
  } else {
    c = !1, b = a.byteOffset;
  }
  return {o:b, M:c};
}, hb(a, b, c, d) {
  M.m.write(a, b, 0, d, c, !1);
  return 0;
},},};
function tb(a, b) {
  var c = 0;
  a && (c |= 365);
  b && (c |= 146);
  return c;
}
var ub = null, vb = {}, wb = [], xb = 1, yb = null, zb = !0, L = null, qb = {}, Bb = (a, b = {}) => {
  a = bb(a);
  if (!a) {
    return {path:"", node:null};
  }
  b = Object.assign({ab:!0, Qa:0}, b);
  if (8 < b.Qa) {
    throw new L(32);
  }
  a = a.split("/").filter(g => !!g);
  for (var c = ub, d = "/", e = 0; e < a.length; e++) {
    var f = e === a.length - 1;
    if (f && b.parent) {
      break;
    }
    c = sb(c, a[e]);
    d = Xa(d + "/" + a[e]);
    c.Aa && (!f || f && b.ab) && (c = c.Aa.root);
    if (!f || b.$a) {
      for (f = 0; 40960 === (c.mode & 61440);) {
        if (c = Ab(d), d = bb(Ya(d), c), c = Bb(d, {Qa:b.Qa + 1}).node, 40 < f++) {
          throw new L(32);
        }
      }
    }
  }
  return {path:d, node:c};
}, Cb = a => {
  for (var b;;) {
    if (a === a.parent) {
      return a = a.T.gb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
    }
    b = b ? `${a.name}/${b}` : a.name;
    a = a.parent;
  }
}, Db = (a, b) => {
  for (var c = 0, d = 0; d < b.length; d++) {
    c = (c << 5) - c + b.charCodeAt(d) | 0;
  }
  return (a + c >>> 0) % yb.length;
}, sb = (a, b) => {
  var c;
  if (c = (c = Eb(a, "x")) ? c : a.l.ma ? 0 : 2) {
    throw new L(c, a);
  }
  for (c = yb[Db(a.id, b)]; c; c = c.Zb) {
    var d = c.name;
    if (c.parent.id === a.id && d === b) {
      return c;
    }
  }
  return a.l.ma(a, b);
}, pb = (a, b, c, d) => {
  a = new Fb(a, b, c, d);
  b = Db(a.parent.id, a.name);
  a.Zb = yb[b];
  return yb[b] = a;
}, Gb = a => {
  var b = ["r", "w", "rw"][a & 3];
  a & 512 && (b += "w");
  return b;
}, Eb = (a, b) => {
  if (zb) {
    return 0;
  }
  if (!b.includes("r") || a.mode & 292) {
    if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) {
      return 2;
    }
  } else {
    return 2;
  }
  return 0;
}, Hb = (a, b) => {
  try {
    return sb(a, b), 20;
  } catch (c) {
  }
  return Eb(a, "wx");
}, Ib = () => {
  for (var a = 0; 4096 >= a; a++) {
    if (!wb[a]) {
      return a;
    }
  }
  throw new L(33);
}, Jb = a => {
  a = wb[a];
  if (!a) {
    throw new L(8);
  }
  return a;
}, Lb = (a, b = -1) => {
  Kb || (Kb = function() {
    this.h = {};
  }, Kb.prototype = {}, Object.defineProperties(Kb.prototype, {object:{get() {
    return this.node;
  }, set(c) {
    this.node = c;
  }}, flags:{get() {
    return this.h.flags;
  }, set(c) {
    this.h.flags = c;
  },}, position:{get() {
    return this.h.position;
  }, set(c) {
    this.h.position = c;
  },},}));
  a = Object.assign(new Kb(), a);
  -1 == b && (b = Ib());
  a.W = b;
  return wb[b] = a;
}, ob = {open:a => {
  a.m = vb[a.node.Ca].m;
  a.m.open && a.m.open(a);
}, aa:() => {
  throw new L(70);
},}, jb = (a, b) => {
  vb[a] = {m:b};
}, Mb = (a, b) => {
  var c = "/" === b, d = !b;
  if (c && ub) {
    throw new L(10);
  }
  if (!c && !d) {
    var e = Bb(b, {ab:!1});
    b = e.path;
    e = e.node;
    if (e.Aa) {
      throw new L(10);
    }
    if (16384 !== (e.mode & 61440)) {
      throw new L(54);
    }
  }
  b = {type:a, Lc:{}, gb:b, Yb:[]};
  a = a.T(b);
  a.T = b;
  b.root = a;
  c ? ub = a : e && (e.Aa = b, e.T && e.T.Yb.push(b));
}, N = (a, b, c) => {
  var d = Bb(a, {parent:!0}).node;
  a = Za(a);
  if (!a || "." === a || ".." === a) {
    throw new L(28);
  }
  var e = Hb(d, a);
  if (e) {
    throw new L(e);
  }
  if (!d.l.za) {
    throw new L(63);
  }
  return d.l.za(d, a, b, c);
}, Nb = (a, b, c) => {
  "undefined" == typeof c && (c = b, b = 438);
  N(a, b | 8192, c);
}, Ob = (a, b) => {
  if (!bb(a)) {
    throw new L(44);
  }
  var c = Bb(b, {parent:!0}).node;
  if (!c) {
    throw new L(44);
  }
  b = Za(b);
  var d = Hb(c, b);
  if (d) {
    throw new L(d);
  }
  if (!c.l.Fa) {
    throw new L(63);
  }
  c.l.Fa(c, b, a);
}, Ab = a => {
  a = Bb(a).node;
  if (!a) {
    throw new L(44);
  }
  if (!a.l.na) {
    throw new L(28);
  }
  return bb(Cb(a.parent), a.l.na(a));
}, Qb = (a, b, c) => {
  if ("" === a) {
    throw new L(44);
  }
  if ("string" == typeof b) {
    var d = {r:0, "r+":2, w:577, "w+":578, a:1089, "a+":1090,}[b];
    if ("undefined" == typeof d) {
      throw Error(`Unknown file open mode: ${b}`);
    }
    b = d;
  }
  c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
  if ("object" == typeof a) {
    var e = a;
  } else {
    a = Xa(a);
    try {
      e = Bb(a, {$a:!(b & 131072)}).node;
    } catch (f) {
    }
  }
  d = !1;
  if (b & 64) {
    if (e) {
      if (b & 128) {
        throw new L(20);
      }
    } else {
      e = N(a, c, 0), d = !0;
    }
  }
  if (!e) {
    throw new L(44);
  }
  8192 === (e.mode & 61440) && (b &= -513);
  if (b & 65536 && 16384 !== (e.mode & 61440)) {
    throw new L(54);
  }
  if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Gb(b) || b & 512) ? 31 : Eb(e, Gb(b)) : 44)) {
    throw new L(c);
  }
  if (b & 512 && !d) {
    c = e;
    c = "string" == typeof c ? Bb(c, {$a:!0}).node : c;
    if (!c.l.P) {
      throw new L(63);
    }
    if (16384 === (c.mode & 61440)) {
      throw new L(31);
    }
    if (32768 !== (c.mode & 61440)) {
      throw new L(28);
    }
    if (d = Eb(c, "w")) {
      throw new L(d);
    }
    c.l.P(c, {size:0, timestamp:Date.now()});
  }
  b &= -131713;
  e = Lb({node:e, path:Cb(e), flags:b, seekable:!0, position:0, m:e.m, mc:[], error:!1});
  e.m.open && e.m.open(e);
  !n.logReadFiles || b & 1 || (Pb || (Pb = {}), a in Pb || (Pb[a] = 1));
  return e;
}, Rb = (a, b, c) => {
  if (null === a.W) {
    throw new L(8);
  }
  if (!a.seekable || !a.m.aa) {
    throw new L(70);
  }
  if (0 != c && 1 != c && 2 != c) {
    throw new L(28);
  }
  a.position = a.m.aa(a, b, c);
  a.mc = [];
}, Sb = () => {
  L || (L = function(a, b) {
    this.name = "ErrnoError";
    this.node = b;
    this.bc = function(c) {
      this.$ = c;
    };
    this.bc(a);
    this.message = "FS error";
  }, L.prototype = Error(), L.prototype.constructor = L, [44].forEach(a => {
    qb[a] = new L(a);
    qb[a].stack = "<generic error, no stack>";
  }));
}, Tb, Vb = (a, b, c) => {
  a = Xa("/dev/" + a);
  var d = tb(!!b, !!c);
  Ub || (Ub = 64);
  var e = Ub++ << 8 | 0;
  jb(e, {open:f => {
    f.seekable = !1;
  }, close:() => {
    c && c.buffer && c.buffer.length && c(10);
  }, read:(f, g, m, p) => {
    for (var l = 0, t = 0; t < p; t++) {
      try {
        var u = b();
      } catch (x) {
        throw new L(29);
      }
      if (void 0 === u && 0 === l) {
        throw new L(6);
      }
      if (null === u || void 0 === u) {
        break;
      }
      l++;
      g[m + t] = u;
    }
    l && (f.node.timestamp = Date.now());
    return l;
  }, write:(f, g, m, p) => {
    for (var l = 0; l < p; l++) {
      try {
        c(g[m + l]);
      } catch (t) {
        throw new L(29);
      }
    }
    p && (f.node.timestamp = Date.now());
    return l;
  }});
  Nb(a, d, e);
}, Ub, Wb = {}, Kb, Pb, Xb = void 0;
function Yb() {
  Xb += 4;
  return I[Xb - 4 >> 2];
}
function Zb(a) {
  if (void 0 === a) {
    return "_unknown";
  }
  a = a.replace(/[^a-zA-Z0-9_]/g, "$");
  var b = a.charCodeAt(0);
  return 48 <= b && 57 >= b ? `_${a}` : a;
}
function $b(a, b) {
  a = Zb(a);
  return {[a]:function() {
    return b.apply(this, arguments);
  }}[a];
}
function ac() {
  this.M = [void 0];
  this.bb = [];
}
var O = new ac(), bc = void 0;
function P(a) {
  throw new bc(a);
}
var Q = a => {
  a || P("Cannot use deleted val. handle = " + a);
  return O.get(a).value;
}, cc = a => {
  switch(a) {
    case void 0:
      return 1;
    case null:
      return 2;
    case !0:
      return 3;
    case !1:
      return 4;
    default:
      return O.ta({ob:1, value:a});
  }
};
function dc(a) {
  var b = Error, c = $b(a, function(d) {
    this.name = a;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(b.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}
var ec = void 0, fc = void 0;
function R(a) {
  for (var b = ""; C[a];) {
    b += fc[C[a++]];
  }
  return b;
}
var gc = [];
function hc() {
  for (; gc.length;) {
    var a = gc.pop();
    a.g.ga = !1;
    a["delete"]();
  }
}
var ic = void 0, jc = {};
function kc(a, b) {
  for (void 0 === b && P("ptr should not be undefined"); a.A;) {
    b = a.pa(b), a = a.A;
  }
  return b;
}
var lc = {};
function mc(a) {
  a = nc(a);
  var b = R(a);
  oc(a);
  return b;
}
function pc(a, b) {
  var c = lc[a];
  void 0 === c && P(b + " has unknown type " + mc(a));
  return c;
}
function qc() {
}
var rc = !1;
function sc(a) {
  --a.count.value;
  0 === a.count.value && (a.G ? a.L.V(a.G) : a.u.i.V(a.o));
}
function tc(a, b, c) {
  if (b === c) {
    return a;
  }
  if (void 0 === c.A) {
    return null;
  }
  a = tc(a, b, c.A);
  return null === a ? null : c.Gb(a);
}
var uc = {};
function vc(a, b) {
  b = kc(a, b);
  return jc[b];
}
var wc = void 0;
function xc(a) {
  throw new wc(a);
}
function yc(a, b) {
  b.u && b.o || xc("makeClassHandle requires ptr and ptrType");
  !!b.L !== !!b.G && xc("Both smartPtrType and smartPtr must be specified");
  b.count = {value:1};
  return zc(Object.create(a, {g:{value:b,},}));
}
function zc(a) {
  if ("undefined" === typeof FinalizationRegistry) {
    return zc = b => b, a;
  }
  rc = new FinalizationRegistry(b => {
    sc(b.g);
  });
  zc = b => {
    var c = b.g;
    c.G && rc.register(b, {g:c}, b);
    return b;
  };
  qc = b => {
    rc.unregister(b);
  };
  return zc(a);
}
var Ac = {};
function Bc(a) {
  for (; a.length;) {
    var b = a.pop();
    a.pop()(b);
  }
}
function Cc(a) {
  return this.fromWireType(I[a >> 2]);
}
var Dc = {}, Ec = {};
function S(a, b, c) {
  function d(m) {
    m = c(m);
    m.length !== a.length && xc("Mismatched type converter count");
    for (var p = 0; p < a.length; ++p) {
      T(a[p], m[p]);
    }
  }
  a.forEach(function(m) {
    Ec[m] = b;
  });
  var e = Array(b.length), f = [], g = 0;
  b.forEach((m, p) => {
    lc.hasOwnProperty(m) ? e[p] = lc[m] : (f.push(m), Dc.hasOwnProperty(m) || (Dc[m] = []), Dc[m].push(() => {
      e[p] = lc[m];
      ++g;
      g === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
}
function Fc(a) {
  switch(a) {
    case 1:
      return 0;
    case 2:
      return 1;
    case 4:
      return 2;
    case 8:
      return 3;
    default:
      throw new TypeError(`Unknown type size: ${a}`);
  }
}
function Gc(a, b, c = {}) {
  var d = b.name;
  a || P(`type "${d}" must have a positive integer typeid pointer`);
  if (lc.hasOwnProperty(a)) {
    if (c.Rb) {
      return;
    }
    P(`Cannot register type '${d}' twice`);
  }
  lc[a] = b;
  delete Ec[a];
  Dc.hasOwnProperty(a) && (b = Dc[a], delete Dc[a], b.forEach(e => e()));
}
function T(a, b, c = {}) {
  if (!("argPackAdvance" in b)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  Gc(a, b, c);
}
function Hc(a) {
  P(a.g.u.i.name + " instance already deleted");
}
function Ic() {
}
function Jc(a, b, c) {
  if (void 0 === a[b].B) {
    var d = a[b];
    a[b] = function() {
      a[b].B.hasOwnProperty(arguments.length) || P(`Function '${c}' called with an invalid number of arguments (${arguments.length}) - expects one of (${a[b].B})!`);
      return a[b].B[arguments.length].apply(this, arguments);
    };
    a[b].B = [];
    a[b].B[d.fa] = d;
  }
}
function Kc(a, b, c) {
  n.hasOwnProperty(a) ? ((void 0 === c || void 0 !== n[a].B && void 0 !== n[a].B[c]) && P(`Cannot register public name '${a}' twice`), Jc(n, a, a), n.hasOwnProperty(c) && P(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`), n[a].B[c] = b) : (n[a] = b, void 0 !== c && (n[a].Kc = c));
}
function Lc(a, b, c, d, e, f, g, m) {
  this.name = a;
  this.constructor = b;
  this.N = c;
  this.V = d;
  this.A = e;
  this.Lb = f;
  this.pa = g;
  this.Gb = m;
  this.kb = [];
}
function Mc(a, b, c) {
  for (; b !== c;) {
    b.pa || P(`Expected null or instance of ${c.name}, got an instance of ${b.name}`), a = b.pa(a), b = b.A;
  }
  return a;
}
function Nc(a, b) {
  if (null === b) {
    return this.Na && P(`null is not a valid ${this.name}`), 0;
  }
  b.g || P(`Cannot pass "${Oc(b)}" as a ${this.name}`);
  b.g.o || P(`Cannot pass deleted object as a pointer of type ${this.name}`);
  return Mc(b.g.o, b.g.u.i, this.i);
}
function Pc(a, b) {
  if (null === b) {
    this.Na && P(`null is not a valid ${this.name}`);
    if (this.ya) {
      var c = this.Pa();
      null !== a && a.push(this.V, c);
      return c;
    }
    return 0;
  }
  b.g || P(`Cannot pass "${Oc(b)}" as a ${this.name}`);
  b.g.o || P(`Cannot pass deleted object as a pointer of type ${this.name}`);
  !this.xa && b.g.u.xa && P(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
  c = Mc(b.g.o, b.g.u.i, this.i);
  if (this.ya) {
    switch(void 0 === b.g.G && P("Passing raw pointer to smart pointer is illegal"), this.fc) {
      case 0:
        b.g.L === this ? c = b.g.G : P(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
        break;
      case 1:
        c = b.g.G;
        break;
      case 2:
        if (b.g.L === this) {
          c = b.g.G;
        } else {
          var d = b.clone();
          c = this.ac(c, cc(function() {
            d["delete"]();
          }));
          null !== a && a.push(this.V, c);
        }
        break;
      default:
        P("Unsupporting sharing policy");
    }
  }
  return c;
}
function Qc(a, b) {
  if (null === b) {
    return this.Na && P(`null is not a valid ${this.name}`), 0;
  }
  b.g || P(`Cannot pass "${Oc(b)}" as a ${this.name}`);
  b.g.o || P(`Cannot pass deleted object as a pointer of type ${this.name}`);
  b.g.u.xa && P(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
  return Mc(b.g.o, b.g.u.i, this.i);
}
function Rc(a, b, c, d) {
  this.name = a;
  this.i = b;
  this.Na = c;
  this.xa = d;
  this.ya = !1;
  this.V = this.ac = this.Pa = this.mb = this.fc = this.$b = void 0;
  void 0 !== b.A ? this.toWireType = Pc : (this.toWireType = d ? Nc : Qc, this.K = null);
}
function Sc(a, b, c) {
  n.hasOwnProperty(a) || xc("Replacing nonexistant public symbol");
  void 0 !== n[a].B && void 0 !== c ? n[a].B[c] = b : (n[a] = b, n[a].fa = c);
}
var Tc = [], Uc = a => {
  var b = Tc[a];
  b || (a >= Tc.length && (Tc.length = a + 1), Tc[a] = b = Aa.get(a));
  return b;
}, Vc = (a, b) => {
  var c = [];
  return function() {
    c.length = 0;
    Object.assign(c, arguments);
    if (a.includes("j")) {
      var d = n["dynCall_" + a];
      d = c && c.length ? d.apply(null, [b].concat(c)) : d.call(null, b);
    } else {
      d = Uc(b).apply(null, c);
    }
    return d;
  };
};
function U(a, b) {
  a = R(a);
  var c = a.includes("j") ? Vc(a, b) : Uc(b);
  "function" != typeof c && P(`unknown function pointer with signature ${a}: ${b}`);
  return c;
}
var Wc = void 0;
function Xc(a, b) {
  function c(f) {
    e[f] || lc[f] || (Ec[f] ? Ec[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  b.forEach(c);
  throw new Wc(`${a}: ` + d.map(mc).join([", "]));
}
function Yc(a, b, c, d, e) {
  var f = b.length;
  2 > f && P("argTypes array size mismatch! Must at least get return value and 'this' types!");
  var g = null !== b[1] && null !== c, m = !1;
  for (c = 1; c < b.length; ++c) {
    if (null !== b[c] && void 0 === b[c].K) {
      m = !0;
      break;
    }
  }
  var p = "void" !== b[0].name, l = f - 2, t = Array(l), u = [], x = [];
  return function() {
    arguments.length !== l && P(`function ${a} called with ${arguments.length} arguments, expected ${l} args!`);
    x.length = 0;
    u.length = g ? 2 : 1;
    u[0] = e;
    if (g) {
      var k = b[1].toWireType(x, this);
      u[1] = k;
    }
    for (var q = 0; q < l; ++q) {
      t[q] = b[q + 2].toWireType(x, arguments[q]), u.push(t[q]);
    }
    q = d.apply(null, u);
    if (m) {
      Bc(x);
    } else {
      for (var v = g ? 1 : 2; v < b.length; v++) {
        var y = 1 === v ? k : t[v - 2];
        null !== b[v].K && b[v].K(y);
      }
    }
    k = p ? b[0].fromWireType(q) : void 0;
    return k;
  };
}
function Zc(a, b) {
  for (var c = [], d = 0; d < a; d++) {
    c.push(J[b + 4 * d >> 2]);
  }
  return c;
}
function $c(a, b, c) {
  a instanceof Object || P(`${c} with invalid "this": ${a}`);
  a instanceof b.i.constructor || P(`${c} incompatible with "this" of type ${a.constructor.name}`);
  a.g.o || P(`cannot call emscripten binding method ${c} on deleted object`);
  return Mc(a.g.o, a.g.u.i, b.i);
}
function ad(a) {
  a >= O.h && 0 === --O.get(a).ob && O.Qb(a);
}
function bd(a, b, c) {
  switch(b) {
    case 0:
      return function(d) {
        return this.fromWireType((c ? A : C)[d]);
      };
    case 1:
      return function(d) {
        return this.fromWireType((c ? G : wa)[d >> 1]);
      };
    case 2:
      return function(d) {
        return this.fromWireType((c ? I : J)[d >> 2]);
      };
    default:
      throw new TypeError("Unknown integer type: " + a);
  }
}
function Oc(a) {
  if (null === a) {
    return "null";
  }
  var b = typeof a;
  return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
}
function cd(a, b) {
  switch(b) {
    case 2:
      return function(c) {
        return this.fromWireType(xa[c >> 2]);
      };
    case 3:
      return function(c) {
        return this.fromWireType(ya[c >> 3]);
      };
    default:
      throw new TypeError("Unknown float type: " + a);
  }
}
function dd(a, b, c) {
  switch(b) {
    case 0:
      return c ? function(d) {
        return A[d];
      } : function(d) {
        return C[d];
      };
    case 1:
      return c ? function(d) {
        return G[d >> 1];
      } : function(d) {
        return wa[d >> 1];
      };
    case 2:
      return c ? function(d) {
        return I[d >> 2];
      } : function(d) {
        return J[d >> 2];
      };
    default:
      throw new TypeError("Unknown integer type: " + a);
  }
}
var ed = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, fd = (a, b) => {
  var c = a >> 1;
  for (var d = c + b / 2; !(c >= d) && wa[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - a && ed) {
    return ed.decode(C.subarray(a, c));
  }
  c = "";
  for (d = 0; !(d >= b / 2); ++d) {
    var e = G[a + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, gd = (a, b, c) => {
  void 0 === c && (c = 2147483647);
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = b;
  c = c < 2 * a.length ? c / 2 : a.length;
  for (var e = 0; e < c; ++e) {
    G[b >> 1] = a.charCodeAt(e), b += 2;
  }
  G[b >> 1] = 0;
  return b - d;
}, hd = a => 2 * a.length, jd = (a, b) => {
  for (var c = 0, d = ""; !(c >= b / 4);) {
    var e = I[a + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, kd = (a, b, c) => {
  void 0 === c && (c = 2147483647);
  if (4 > c) {
    return 0;
  }
  var d = b;
  c = d + c - 4;
  for (var e = 0; e < a.length; ++e) {
    var f = a.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var g = a.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | g & 1023;
    }
    I[b >> 2] = f;
    b += 4;
    if (b + 4 > c) {
      break;
    }
  }
  I[b >> 2] = 0;
  return b - d;
}, ld = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    b += 4;
  }
  return b;
}, md = {};
function nd(a) {
  var b = md[a];
  return void 0 === b ? R(a) : b;
}
var od = [];
function pd(a) {
  var b = od.length;
  od.push(a);
  return b;
}
function qd(a, b) {
  for (var c = Array(a), d = 0; d < a; ++d) {
    c[d] = pc(J[b + 4 * d >> 2], "parameter " + d);
  }
  return c;
}
var rd = [], sd = [];
function td(a) {
  a.yc = a.getExtension("WEBGL_draw_instanced_base_vertex_base_instance");
}
function ud(a) {
  a.Gc = a.getExtension("WEBGL_multi_draw_instanced_base_vertex_base_instance");
}
var vd = 1, wd = [], V = [], xd = [], yd = [], W = [], zd = [], Ad = [], r = [], Bd = {};
function X(a) {
  Cd || (Cd = a);
}
function ha(a) {
  for (var b = vd++, c = a.length; c < b; c++) {
    a[c] = null;
  }
  return b;
}
function ja(a) {
  Dd = r[a];
  n.wc = Y = Dd && Dd.H;
  return !(a && !Y);
}
function ia(a) {
  a || (a = Dd);
  if (!a.Sb) {
    a.Sb = !0;
    var b = a.H;
    td(b);
    ud(b);
    2 <= a.version && (b.Ya = b.getExtension("EXT_disjoint_timer_query_webgl2"));
    if (2 > a.version || !b.Ya) {
      b.Ya = b.getExtension("EXT_disjoint_timer_query");
    }
    Ed(b);
    (b.getSupportedExtensions() || []).forEach(function(c) {
      c.includes("lose_context") || c.includes("debug") || b.getExtension(c);
    });
  }
}
var Cd, Dd;
function Ed(a) {
  a.Ic = a.getExtension("WEBGL_multi_draw");
}
var Fd = {}, Hd = () => {
  if (!Gd) {
    var a = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:la || "./this.program"}, b;
    for (b in Fd) {
      void 0 === Fd[b] ? delete a[b] : a[b] = Fd[b];
    }
    var c = [];
    for (b in a) {
      c.push(`${b}=${a[b]}`);
    }
    Gd = c;
  }
  return Gd;
}, Gd, Id = [];
function Jd(a, b, c, d) {
  for (var e = 0; e < a; e++) {
    var f = Y[c](), g = f && ha(d);
    f ? (f.name = g, d[g] = f) : X(1282);
    I[b + 4 * e >> 2] = g;
  }
}
function Kd(a, b) {
  if (b) {
    var c = void 0;
    switch(a) {
      case 36346:
        c = 1;
        break;
      case 36344:
        return;
      case 34814:
      case 36345:
        c = 0;
        break;
      case 34466:
        var d = Y.getParameter(34467);
        c = d ? d.length : 0;
        break;
      case 33309:
        if (2 > Dd.version) {
          X(1282);
          return;
        }
        c = 2 * (Y.getSupportedExtensions() || []).length;
        break;
      case 33307:
      case 33308:
        if (2 > Dd.version) {
          X(1280);
          return;
        }
        c = 33307 == a ? 3 : 0;
    }
    if (void 0 === c) {
      switch(d = Y.getParameter(a), typeof d) {
        case "number":
          c = d;
          break;
        case "boolean":
          c = d ? 1 : 0;
          break;
        case "string":
          X(1280);
          return;
        case "object":
          if (null === d) {
            switch(a) {
              case 34964:
              case 35725:
              case 34965:
              case 36006:
              case 36007:
              case 32873:
              case 34229:
              case 36662:
              case 36663:
              case 35053:
              case 35055:
              case 36010:
              case 35097:
              case 35869:
              case 32874:
              case 36389:
              case 35983:
              case 35368:
              case 34068:
                c = 0;
                break;
              default:
                X(1280);
                return;
            }
          } else {
            if (d instanceof Float32Array || d instanceof Uint32Array || d instanceof Int32Array || d instanceof Array) {
              for (a = 0; a < d.length; ++a) {
                I[b + 4 * a >> 2] = d[a];
              }
              return;
            }
            try {
              c = d.name | 0;
            } catch (e) {
              X(1280);
              ra("GL_INVALID_ENUM in glGet0v: Unknown object returned from WebGL getParameter(" + a + ")! (error: " + e + ")");
              return;
            }
          }
          break;
        default:
          X(1280);
          ra("GL_INVALID_ENUM in glGet0v: Native code calling glGet0v(" + a + ") and it returns " + d + " of type " + typeof d + "!");
          return;
      }
    }
    I[b >> 2] = c;
  } else {
    X(1281);
  }
}
var Md = a => {
  var b = eb(a) + 1, c = Ld(b);
  c && fb(a, C, c, b);
  return c;
};
function Nd(a) {
  return "]" == a.slice(-1) && a.lastIndexOf("[");
}
var Od = a => 0 === a % 4 && (0 !== a % 100 || 0 === a % 400), Pd = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Qd = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Rd = (a, b, c, d) => {
  function e(k, q, v) {
    for (k = "number" == typeof k ? k.toString() : k || ""; k.length < q;) {
      k = v[0] + k;
    }
    return k;
  }
  function f(k, q) {
    return e(k, q, "0");
  }
  function g(k, q) {
    function v(B) {
      return 0 > B ? -1 : 0 < B ? 1 : 0;
    }
    var y;
    0 === (y = v(k.getFullYear() - q.getFullYear())) && 0 === (y = v(k.getMonth() - q.getMonth())) && (y = v(k.getDate() - q.getDate()));
    return y;
  }
  function m(k) {
    switch(k.getDay()) {
      case 0:
        return new Date(k.getFullYear() - 1, 11, 29);
      case 1:
        return k;
      case 2:
        return new Date(k.getFullYear(), 0, 3);
      case 3:
        return new Date(k.getFullYear(), 0, 2);
      case 4:
        return new Date(k.getFullYear(), 0, 1);
      case 5:
        return new Date(k.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(k.getFullYear() - 1, 11, 30);
    }
  }
  function p(k) {
    var q = k.ba;
    for (k = new Date((new Date(k.ca + 1900, 0, 1)).getTime()); 0 < q;) {
      var v = k.getMonth(), y = (Od(k.getFullYear()) ? Pd : Qd)[v];
      if (q > y - k.getDate()) {
        q -= y - k.getDate() + 1, k.setDate(1), 11 > v ? k.setMonth(v + 1) : (k.setMonth(0), k.setFullYear(k.getFullYear() + 1));
      } else {
        k.setDate(k.getDate() + q);
        break;
      }
    }
    v = new Date(k.getFullYear() + 1, 0, 4);
    q = m(new Date(k.getFullYear(), 0, 4));
    v = m(v);
    return 0 >= g(q, k) ? 0 >= g(v, k) ? k.getFullYear() + 1 : k.getFullYear() : k.getFullYear() - 1;
  }
  var l = I[d + 40 >> 2];
  d = {jc:I[d >> 2], ic:I[d + 4 >> 2], Ga:I[d + 8 >> 2], Ra:I[d + 12 >> 2], Ha:I[d + 16 >> 2], ca:I[d + 20 >> 2], R:I[d + 24 >> 2], ba:I[d + 28 >> 2], Mc:I[d + 32 >> 2], hc:I[d + 36 >> 2], kc:l ? l ? K(C, l) : "" : ""};
  c = c ? K(C, c) : "";
  l = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var t in l) {
    c = c.replace(new RegExp(t, "g"), l[t]);
  }
  var u = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
  l = {"%a":k => u[k.R].substring(0, 3), "%A":k => u[k.R], "%b":k => x[k.Ha].substring(0, 3), "%B":k => x[k.Ha], "%C":k => f((k.ca + 1900) / 100 | 0, 2), "%d":k => f(k.Ra, 2), "%e":k => e(k.Ra, 2, " "), "%g":k => p(k).toString().substring(2), "%G":k => p(k), "%H":k => f(k.Ga, 2), "%I":k => {
    k = k.Ga;
    0 == k ? k = 12 : 12 < k && (k -= 12);
    return f(k, 2);
  }, "%j":k => {
    for (var q = 0, v = 0; v <= k.Ha - 1; q += (Od(k.ca + 1900) ? Pd : Qd)[v++]) {
    }
    return f(k.Ra + q, 3);
  }, "%m":k => f(k.Ha + 1, 2), "%M":k => f(k.ic, 2), "%n":() => "\n", "%p":k => 0 <= k.Ga && 12 > k.Ga ? "AM" : "PM", "%S":k => f(k.jc, 2), "%t":() => "\t", "%u":k => k.R || 7, "%U":k => f(Math.floor((k.ba + 7 - k.R) / 7), 2), "%V":k => {
    var q = Math.floor((k.ba + 7 - (k.R + 6) % 7) / 7);
    2 >= (k.R + 371 - k.ba - 2) % 7 && q++;
    if (q) {
      53 == q && (v = (k.R + 371 - k.ba) % 7, 4 == v || 3 == v && Od(k.ca) || (q = 1));
    } else {
      q = 52;
      var v = (k.R + 7 - k.ba - 1) % 7;
      (4 == v || 5 == v && Od(k.ca % 400 - 1)) && q++;
    }
    return f(q, 2);
  }, "%w":k => k.R, "%W":k => f(Math.floor((k.ba + 7 - (k.R + 6) % 7) / 7), 2), "%y":k => (k.ca + 1900).toString().substring(2), "%Y":k => k.ca + 1900, "%z":k => {
    k = k.hc;
    var q = 0 <= k;
    k = Math.abs(k) / 60;
    return (q ? "+" : "-") + String("0000" + (k / 60 * 100 + k % 60)).slice(-4);
  }, "%Z":k => k.kc, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (t in l) {
    c.includes(t) && (c = c.replace(new RegExp(t, "g"), l[t](d)));
  }
  c = c.replace(/\0\0/g, "%");
  t = gb(c, !1);
  if (t.length > b) {
    return 0;
  }
  A.set(t, a);
  return t.length - 1;
};
function Fb(a, b, c, d) {
  a || (a = this);
  this.parent = a;
  this.T = a.T;
  this.Aa = null;
  this.id = xb++;
  this.name = b;
  this.mode = c;
  this.l = {};
  this.m = {};
  this.Ca = d;
}
Object.defineProperties(Fb.prototype, {read:{get:function() {
  return 365 === (this.mode & 365);
}, set:function(a) {
  a ? this.mode |= 365 : this.mode &= -366;
}}, write:{get:function() {
  return 146 === (this.mode & 146);
}, set:function(a) {
  a ? this.mode |= 146 : this.mode &= -147;
}}});
Sb();
yb = Array(4096);
Mb(M, "/");
N("/tmp", 16895, 0);
N("/home", 16895, 0);
N("/home/web_user", 16895, 0);
(() => {
  N("/dev", 16895, 0);
  jb(259, {read:() => 0, write:(d, e, f, g) => g,});
  Nb("/dev/null", 259);
  ib(1280, lb);
  ib(1536, mb);
  Nb("/dev/tty", 1280);
  Nb("/dev/tty1", 1536);
  var a = new Uint8Array(1024), b = 0, c = () => {
    0 === b && (b = ab(a).byteLength);
    return a[--b];
  };
  Vb("random", c);
  Vb("urandom", c);
  N("/dev/shm", 16895, 0);
  N("/dev/shm/tmp", 16895, 0);
})();
(() => {
  N("/proc", 16895, 0);
  var a = N("/proc/self", 16895, 0);
  N("/proc/self/fd", 16895, 0);
  Mb({T:() => {
    var b = pb(a, "fd", 16895, 73);
    b.l = {ma:(c, d) => {
      var e = Jb(+d);
      c = {parent:null, T:{gb:"fake"}, l:{na:() => e.path},};
      return c.parent = c;
    }};
    return b;
  }}, "/proc/self/fd");
})();
Object.assign(ac.prototype, {get(a) {
  return this.M[a];
}, has(a) {
  return void 0 !== this.M[a];
}, ta(a) {
  var b = this.bb.pop() || this.M.length;
  this.M[b] = a;
  return b;
}, Qb(a) {
  this.M[a] = void 0;
  this.bb.push(a);
}});
bc = n.BindingError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "BindingError";
  }
};
O.M.push({value:void 0}, {value:null}, {value:!0}, {value:!1},);
O.h = O.M.length;
n.count_emval_handles = function() {
  for (var a = 0, b = O.h; b < O.M.length; ++b) {
    void 0 !== O.M[b] && ++a;
  }
  return a;
};
ec = n.PureVirtualError = dc("PureVirtualError");
for (var Sd = Array(256), Td = 0; 256 > Td; ++Td) {
  Sd[Td] = String.fromCharCode(Td);
}
fc = Sd;
n.getInheritedInstanceCount = function() {
  return Object.keys(jc).length;
};
n.getLiveInheritedInstances = function() {
  var a = [], b;
  for (b in jc) {
    jc.hasOwnProperty(b) && a.push(jc[b]);
  }
  return a;
};
n.flushPendingDeletes = hc;
n.setDelayFunction = function(a) {
  ic = a;
  gc.length && ic && ic(hc);
};
wc = n.InternalError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "InternalError";
  }
};
Ic.prototype.isAliasOf = function(a) {
  if (!(this instanceof Ic && a instanceof Ic)) {
    return !1;
  }
  var b = this.g.u.i, c = this.g.o, d = a.g.u.i;
  for (a = a.g.o; b.A;) {
    c = b.pa(c), b = b.A;
  }
  for (; d.A;) {
    a = d.pa(a), d = d.A;
  }
  return b === d && c === a;
};
Ic.prototype.clone = function() {
  this.g.o || Hc(this);
  if (this.g.ja) {
    return this.g.count.value += 1, this;
  }
  var a = zc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
  a = a(c.call(b, d, {g:{value:{count:e.count, ga:e.ga, ja:e.ja, o:e.o, u:e.u, G:e.G, L:e.L,},}}));
  a.g.count.value += 1;
  a.g.ga = !1;
  return a;
};
Ic.prototype["delete"] = function() {
  this.g.o || Hc(this);
  this.g.ga && !this.g.ja && P("Object already scheduled for deletion");
  qc(this);
  sc(this.g);
  this.g.ja || (this.g.G = void 0, this.g.o = void 0);
};
Ic.prototype.isDeleted = function() {
  return !this.g.o;
};
Ic.prototype.deleteLater = function() {
  this.g.o || Hc(this);
  this.g.ga && !this.g.ja && P("Object already scheduled for deletion");
  gc.push(this);
  1 === gc.length && ic && ic(hc);
  this.g.ga = !0;
  return this;
};
Rc.prototype.Mb = function(a) {
  this.mb && (a = this.mb(a));
  return a;
};
Rc.prototype.Xa = function(a) {
  this.V && this.V(a);
};
Rc.prototype.argPackAdvance = 8;
Rc.prototype.readValueFromPointer = Cc;
Rc.prototype.deleteObject = function(a) {
  if (null !== a) {
    a["delete"]();
  }
};
Rc.prototype.fromWireType = function(a) {
  function b() {
    return this.ya ? yc(this.i.N, {u:this.$b, o:c, L:this, G:a,}) : yc(this.i.N, {u:this, o:a,});
  }
  var c = this.Mb(a);
  if (!c) {
    return this.Xa(a), null;
  }
  var d = vc(this.i, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.o = c, d.g.G = a, d.clone();
    }
    d = d.clone();
    this.Xa(a);
    return d;
  }
  d = this.i.Lb(c);
  d = uc[d];
  if (!d) {
    return b.call(this);
  }
  d = this.xa ? d.Db : d.pointerType;
  var e = tc(c, this.i, d.i);
  return null === e ? b.call(this) : this.ya ? yc(d.i.N, {u:d, o:e, L:this, G:a,}) : yc(d.i.N, {u:d, o:e,});
};
Wc = n.UnboundTypeError = dc("UnboundTypeError");
for (var Y, Ud = 0; 32 > Ud; ++Ud) {
  Id.push(Array(Ud));
}
var Wd = {__syscall_fcntl64:function(a, b, c) {
  Xb = c;
  try {
    var d = Jb(a);
    switch(b) {
      case 0:
        var e = Yb();
        return 0 > e ? -28 : Lb(d, e).W;
      case 1:
      case 2:
        return 0;
      case 3:
        return d.flags;
      case 4:
        return e = Yb(), d.flags |= e, 0;
      case 5:
        return e = Yb(), G[e + 0 >> 1] = 2, 0;
      case 6:
      case 7:
        return 0;
      case 16:
      case 8:
        return -28;
      case 9:
        return I[Vd() >> 2] = 28, -1;
      default:
        return -28;
    }
  } catch (f) {
    if ("undefined" == typeof Wb || "ErrnoError" !== f.name) {
      throw f;
    }
    return -f.$;
  }
}, __syscall_ioctl:function(a, b, c) {
  Xb = c;
  try {
    var d = Jb(a);
    switch(b) {
      case 21509:
        return d.s ? 0 : -59;
      case 21505:
        if (!d.s) {
          return -59;
        }
        if (d.s.U.Ub) {
          b = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,];
          var e = Yb();
          I[e >> 2] = 25856;
          I[e + 4 >> 2] = 5;
          I[e + 8 >> 2] = 191;
          I[e + 12 >> 2] = 35387;
          for (var f = 0; 32 > f; f++) {
            A[e + f + 17 >> 0] = b[f] || 0;
          }
        }
        return 0;
      case 21510:
      case 21511:
      case 21512:
        return d.s ? 0 : -59;
      case 21506:
      case 21507:
      case 21508:
        if (!d.s) {
          return -59;
        }
        if (d.s.U.Vb) {
          for (e = Yb(), b = [], f = 0; 32 > f; f++) {
            b.push(A[e + f + 17 >> 0]);
          }
        }
        return 0;
      case 21519:
        if (!d.s) {
          return -59;
        }
        e = Yb();
        return I[e >> 2] = 0;
      case 21520:
        return d.s ? -28 : -59;
      case 21531:
        e = Yb();
        if (!d.m.Tb) {
          throw new L(59);
        }
        return d.m.Tb(d, b, e);
      case 21523:
        if (!d.s) {
          return -59;
        }
        d.s.U.Wb && (f = [24, 80], e = Yb(), G[e >> 1] = f[0], G[e + 2 >> 1] = f[1]);
        return 0;
      case 21524:
        return d.s ? 0 : -59;
      case 21515:
        return d.s ? 0 : -59;
      default:
        return -28;
    }
  } catch (g) {
    if ("undefined" == typeof Wb || "ErrnoError" !== g.name) {
      throw g;
    }
    return -g.$;
  }
}, __syscall_openat:function(a, b, c, d) {
  Xb = d;
  try {
    b = b ? K(C, b) : "";
    var e = b;
    if ("/" === e.charAt(0)) {
      b = e;
    } else {
      var f = -100 === a ? "/" : Jb(a).path;
      if (0 == e.length) {
        throw new L(44);
      }
      b = Xa(f + "/" + e);
    }
    var g = d ? Yb() : 0;
    return Qb(b, c, g).W;
  } catch (m) {
    if ("undefined" == typeof Wb || "ErrnoError" !== m.name) {
      throw m;
    }
    return -m.$;
  }
}, _embind_create_inheriting_constructor:function(a, b, c) {
  a = R(a);
  b = pc(b, "wrapper");
  c = Q(c);
  var d = [].slice, e = b.i, f = e.N, g = e.A.N, m = e.A.constructor;
  a = $b(a, function() {
    e.A.kb.forEach(function(l) {
      if (this[l] === g[l]) {
        throw new ec(`Pure virtual function ${l} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:f});
    this.__construct.apply(this, d.call(arguments));
  });
  f.__construct = function() {
    this === f && P("Pass correct 'this' to __construct");
    var l = m.implement.apply(void 0, [this].concat(d.call(arguments)));
    qc(l);
    var t = l.g;
    l.notifyOnDestruction();
    t.ja = !0;
    Object.defineProperties(this, {g:{value:t}});
    zc(this);
    l = t.o;
    l = kc(e, l);
    jc.hasOwnProperty(l) ? P(`Tried to register registered instance: ${l}`) : jc[l] = this;
  };
  f.__destruct = function() {
    this === f && P("Pass correct 'this' to __destruct");
    qc(this);
    var l = this.g.o;
    l = kc(e, l);
    jc.hasOwnProperty(l) ? delete jc[l] : P(`Tried to unregister unregistered instance: ${l}`);
  };
  a.prototype = Object.create(f);
  for (var p in c) {
    a.prototype[p] = c[p];
  }
  return cc(a);
}, _embind_finalize_value_object:function(a) {
  var b = Ac[a];
  delete Ac[a];
  var c = b.Pa, d = b.V, e = b.Za, f = e.map(g => g.Pb).concat(e.map(g => g.dc));
  S([a], f, g => {
    var m = {};
    e.forEach((p, l) => {
      var t = g[l], u = p.Nb, x = p.Ob, k = g[l + e.length], q = p.cc, v = p.ec;
      m[p.Jb] = {read:y => t.fromWireType(u(x, y)), write:(y, B) => {
        var D = [];
        q(v, y, k.toWireType(D, B));
        Bc(D);
      }};
    });
    return [{name:b.name, fromWireType:function(p) {
      var l = {}, t;
      for (t in m) {
        l[t] = m[t].read(p);
      }
      d(p);
      return l;
    }, toWireType:function(p, l) {
      for (var t in m) {
        if (!(t in l)) {
          throw new TypeError(`Missing field: "${t}"`);
        }
      }
      var u = c();
      for (t in m) {
        m[t].write(u, l[t]);
      }
      null !== p && p.push(d, u);
      return u;
    }, argPackAdvance:8, readValueFromPointer:Cc, K:d,}];
  });
}, _embind_register_bigint:function() {
}, _embind_register_bool:function(a, b, c, d, e) {
  var f = Fc(c);
  b = R(b);
  T(a, {name:b, fromWireType:function(g) {
    return !!g;
  }, toWireType:function(g, m) {
    return m ? d : e;
  }, argPackAdvance:8, readValueFromPointer:function(g) {
    if (1 === c) {
      var m = A;
    } else if (2 === c) {
      m = G;
    } else if (4 === c) {
      m = I;
    } else {
      throw new TypeError("Unknown boolean type size: " + b);
    }
    return this.fromWireType(m[g >> f]);
  }, K:null,});
}, _embind_register_class:function(a, b, c, d, e, f, g, m, p, l, t, u, x) {
  t = R(t);
  f = U(e, f);
  m && (m = U(g, m));
  l && (l = U(p, l));
  x = U(u, x);
  var k = Zb(t);
  Kc(k, function() {
    Xc(`Cannot construct ${t} due to unbound types`, [d]);
  });
  S([a, b, c], d ? [d] : [], function(q) {
    q = q[0];
    if (d) {
      var v = q.i;
      var y = v.N;
    } else {
      y = Ic.prototype;
    }
    q = $b(k, function() {
      if (Object.getPrototypeOf(this) !== B) {
        throw new bc("Use 'new' to construct " + t);
      }
      if (void 0 === D.Z) {
        throw new bc(t + " has no accessible constructor");
      }
      var H = D.Z[arguments.length];
      if (void 0 === H) {
        throw new bc(`Tried to invoke ctor of ${t} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(D.Z).toString()}) parameters instead!`);
      }
      return H.apply(this, arguments);
    });
    var B = Object.create(y, {constructor:{value:q},});
    q.prototype = B;
    var D = new Lc(t, q, B, x, v, f, m, l);
    D.A && (void 0 === D.A.qa && (D.A.qa = []), D.A.qa.push(D));
    v = new Rc(t, D, !0, !1);
    y = new Rc(t + "*", D, !1, !1);
    var E = new Rc(t + " const*", D, !1, !0);
    uc[a] = {pointerType:y, Db:E};
    Sc(k, q);
    return [v, y, E];
  });
}, _embind_register_class_class_function:function(a, b, c, d, e, f, g) {
  var m = Zc(c, d);
  b = R(b);
  f = U(e, f);
  S([], [a], function(p) {
    function l() {
      Xc(`Cannot call ${t} due to unbound types`, m);
    }
    p = p[0];
    var t = `${p.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    var u = p.i.constructor;
    void 0 === u[b] ? (l.fa = c - 1, u[b] = l) : (Jc(u, b, t), u[b].B[c - 1] = l);
    S([], m, function(x) {
      x = Yc(t, [x[0], null].concat(x.slice(1)), null, f, g);
      void 0 === u[b].B ? (x.fa = c - 1, u[b] = x) : u[b].B[c - 1] = x;
      if (p.i.qa) {
        for (const k of p.i.qa) {
          k.constructor.hasOwnProperty(b) || (k.constructor[b] = x);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:function(a, b, c, d, e, f, g, m) {
  b = R(b);
  f = U(e, f);
  S([], [a], function(p) {
    p = p[0];
    var l = `${p.name}.${b}`, t = {get() {
      Xc(`Cannot access ${l} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    t.set = m ? () => {
      Xc(`Cannot access ${l} due to unbound types`, [c]);
    } : () => {
      P(`${l} is a read-only property`);
    };
    Object.defineProperty(p.i.constructor, b, t);
    S([], [c], function(u) {
      u = u[0];
      var x = {get() {
        return u.fromWireType(f(d));
      }, enumerable:!0};
      m && (m = U(g, m), x.set = k => {
        var q = [];
        m(d, u.toWireType(q, k));
        Bc(q);
      });
      Object.defineProperty(p.i.constructor, b, x);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:function(a, b, c, d, e, f) {
  var g = Zc(b, c);
  e = U(d, e);
  S([], [a], function(m) {
    m = m[0];
    var p = `constructor ${m.name}`;
    void 0 === m.i.Z && (m.i.Z = []);
    if (void 0 !== m.i.Z[b - 1]) {
      throw new bc(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${m.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    m.i.Z[b - 1] = () => {
      Xc(`Cannot construct ${m.name} due to unbound types`, g);
    };
    S([], g, function(l) {
      l.splice(1, 0, null);
      m.i.Z[b - 1] = Yc(p, l, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:function(a, b, c, d, e, f, g, m) {
  var p = Zc(c, d);
  b = R(b);
  f = U(e, f);
  S([], [a], function(l) {
    function t() {
      Xc(`Cannot call ${u} due to unbound types`, p);
    }
    l = l[0];
    var u = `${l.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    m && l.i.kb.push(b);
    var x = l.i.N, k = x[b];
    void 0 === k || void 0 === k.B && k.className !== l.name && k.fa === c - 2 ? (t.fa = c - 2, t.className = l.name, x[b] = t) : (Jc(x, b, u), x[b].B[c - 2] = t);
    S([], p, function(q) {
      q = Yc(u, q, l, f, g);
      void 0 === x[b].B ? (q.fa = c - 2, x[b] = q) : x[b].B[c - 2] = q;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:function(a, b, c, d, e, f, g, m, p, l) {
  b = R(b);
  e = U(d, e);
  S([], [a], function(t) {
    t = t[0];
    var u = `${t.name}.${b}`, x = {get() {
      Xc(`Cannot access ${u} due to unbound types`, [c, g]);
    }, enumerable:!0, configurable:!0};
    x.set = p ? () => {
      Xc(`Cannot access ${u} due to unbound types`, [c, g]);
    } : () => {
      P(u + " is a read-only property");
    };
    Object.defineProperty(t.i.N, b, x);
    S([], p ? [c, g] : [c], function(k) {
      var q = k[0], v = {get() {
        var B = $c(this, t, u + " getter");
        return q.fromWireType(e(f, B));
      }, enumerable:!0};
      if (p) {
        p = U(m, p);
        var y = k[1];
        v.set = function(B) {
          var D = $c(this, t, u + " setter"), E = [];
          p(l, D, y.toWireType(E, B));
          Bc(E);
        };
      }
      Object.defineProperty(t.i.N, b, v);
      return [];
    });
    return [];
  });
}, _embind_register_emval:function(a, b) {
  b = R(b);
  T(a, {name:b, fromWireType:function(c) {
    var d = Q(c);
    ad(c);
    return d;
  }, toWireType:function(c, d) {
    return cc(d);
  }, argPackAdvance:8, readValueFromPointer:Cc, K:null,});
}, _embind_register_enum:function(a, b, c, d) {
  function e() {
  }
  c = Fc(c);
  b = R(b);
  e.values = {};
  T(a, {name:b, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:function(f, g) {
    return g.value;
  }, argPackAdvance:8, readValueFromPointer:bd(b, c, d), K:null,});
  Kc(b, e);
}, _embind_register_enum_value:function(a, b, c) {
  var d = pc(a, "enum");
  b = R(b);
  a = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:$b(`${d.name}_${b}`, function() {
  })},});
  a.values[c] = d;
  a[b] = d;
}, _embind_register_float:function(a, b, c) {
  c = Fc(c);
  b = R(b);
  T(a, {name:b, fromWireType:function(d) {
    return d;
  }, toWireType:function(d, e) {
    return e;
  }, argPackAdvance:8, readValueFromPointer:cd(b, c), K:null,});
}, _embind_register_function:function(a, b, c, d, e, f) {
  var g = Zc(b, c);
  a = R(a);
  e = U(d, e);
  Kc(a, function() {
    Xc(`Cannot call ${a} due to unbound types`, g);
  }, b - 1);
  S([], g, function(m) {
    Sc(a, Yc(a, [m[0], null].concat(m.slice(1)), null, e, f), b - 1);
    return [];
  });
}, _embind_register_integer:function(a, b, c, d, e) {
  b = R(b);
  -1 === e && (e = 4294967295);
  e = Fc(c);
  var f = m => m;
  if (0 === d) {
    var g = 32 - 8 * c;
    f = m => m << g >>> g;
  }
  c = b.includes("unsigned") ? function(m, p) {
    return p >>> 0;
  } : function(m, p) {
    return p;
  };
  T(a, {name:b, fromWireType:f, toWireType:c, argPackAdvance:8, readValueFromPointer:dd(b, e, 0 !== d), K:null,});
}, _embind_register_memory_view:function(a, b, c) {
  function d(f) {
    f >>= 2;
    var g = J;
    return new e(g.buffer, g[f + 1], g[f]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][b];
  c = R(c);
  T(a, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Rb:!0,});
}, _embind_register_std_string:function(a, b) {
  b = R(b);
  var c = "std::string" === b;
  T(a, {name:b, fromWireType:function(d) {
    var e = J[d >> 2], f = d + 4;
    if (c) {
      for (var g = f, m = 0; m <= e; ++m) {
        var p = f + m;
        if (m == e || 0 == C[p]) {
          g = g ? K(C, g, p - g) : "";
          if (void 0 === l) {
            var l = g;
          } else {
            l += String.fromCharCode(0), l += g;
          }
          g = p + 1;
        }
      }
    } else {
      l = Array(e);
      for (m = 0; m < e; ++m) {
        l[m] = String.fromCharCode(C[f + m]);
      }
      l = l.join("");
    }
    oc(d);
    return l;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || P("Cannot pass non-string to std::string");
    var g = c && f ? eb(e) : e.length;
    var m = Ld(4 + g + 1), p = m + 4;
    J[m >> 2] = g;
    if (c && f) {
      fb(e, C, p, g + 1);
    } else {
      if (f) {
        for (f = 0; f < g; ++f) {
          var l = e.charCodeAt(f);
          255 < l && (oc(p), P("String has UTF-16 code units that do not fit in 8 bits"));
          C[p + f] = l;
        }
      } else {
        for (f = 0; f < g; ++f) {
          C[p + f] = e[f];
        }
      }
    }
    null !== d && d.push(oc, m);
    return m;
  }, argPackAdvance:8, readValueFromPointer:Cc, K:function(d) {
    oc(d);
  },});
}, _embind_register_std_wstring:function(a, b, c) {
  c = R(c);
  if (2 === b) {
    var d = fd;
    var e = gd;
    var f = hd;
    var g = () => wa;
    var m = 1;
  } else {
    4 === b && (d = jd, e = kd, f = ld, g = () => J, m = 2);
  }
  T(a, {name:c, fromWireType:function(p) {
    for (var l = J[p >> 2], t = g(), u, x = p + 4, k = 0; k <= l; ++k) {
      var q = p + 4 + k * b;
      if (k == l || 0 == t[q >> m]) {
        x = d(x, q - x), void 0 === u ? u = x : (u += String.fromCharCode(0), u += x), x = q + b;
      }
    }
    oc(p);
    return u;
  }, toWireType:function(p, l) {
    "string" != typeof l && P(`Cannot pass non-string to C++ string type ${c}`);
    var t = f(l), u = Ld(4 + t + b);
    J[u >> 2] = t >> m;
    e(l, u + 4, t + b);
    null !== p && p.push(oc, u);
    return u;
  }, argPackAdvance:8, readValueFromPointer:Cc, K:function(p) {
    oc(p);
  },});
}, _embind_register_value_object:function(a, b, c, d, e, f) {
  Ac[a] = {name:R(b), Pa:U(c, d), V:U(e, f), Za:[],};
}, _embind_register_value_object_field:function(a, b, c, d, e, f, g, m, p, l) {
  Ac[a].Za.push({Jb:R(b), Pb:c, Nb:U(d, e), Ob:f, dc:g, cc:U(m, p), ec:l,});
}, _embind_register_void:function(a, b) {
  b = R(b);
  T(a, {Xb:!0, name:b, argPackAdvance:0, fromWireType:function() {
  }, toWireType:function() {
  },});
}, _emscripten_get_now_is_monotonic:() => !0, _emval_as:function(a, b, c) {
  a = Q(a);
  b = pc(b, "emval::as");
  var d = [], e = cc(d);
  J[c >> 2] = e;
  return b.toWireType(d, a);
}, _emval_call_method:function(a, b, c, d, e) {
  a = od[a];
  b = Q(b);
  c = nd(c);
  var f = [];
  J[d >> 2] = cc(f);
  return a(b, c, f, e);
}, _emval_call_void_method:function(a, b, c, d) {
  a = od[a];
  b = Q(b);
  c = nd(c);
  a(b, c, null, d);
}, _emval_decref:ad, _emval_get_method_caller:function(a, b) {
  var c = qd(a, b), d = c[0];
  b = d.name + "_$" + c.slice(1).map(function(g) {
    return g.name;
  }).join("_") + "$";
  var e = rd[b];
  if (void 0 !== e) {
    return e;
  }
  var f = Array(a - 1);
  e = pd((g, m, p, l) => {
    for (var t = 0, u = 0; u < a - 1; ++u) {
      f[u] = c[u + 1].readValueFromPointer(l + t), t += c[u + 1].argPackAdvance;
    }
    g = g[m].apply(g, f);
    for (u = 0; u < a - 1; ++u) {
      c[u + 1].Fb && c[u + 1].Fb(f[u]);
    }
    if (!d.Xb) {
      return d.toWireType(p, g);
    }
  });
  return rd[b] = e;
}, _emval_get_property:function(a, b) {
  a = Q(a);
  b = Q(b);
  return cc(a[b]);
}, _emval_incref:function(a) {
  4 < a && (O.get(a).ob += 1);
}, _emval_new_cstring:function(a) {
  return cc(nd(a));
}, _emval_new_object:function() {
  return cc({});
}, _emval_run_destructors:function(a) {
  var b = Q(a);
  Bc(b);
  ad(a);
}, _emval_set_property:function(a, b, c) {
  a = Q(a);
  b = Q(b);
  c = Q(c);
  a[b] = c;
}, _emval_take_value:function(a, b) {
  a = pc(a, "_emval_take_value");
  a = a.readValueFromPointer(b);
  return cc(a);
}, abort:() => {
  ta("");
}, beginPixelLocalStorageWEBGL:function(a, b, c) {
  (a = r[a].H.ia) && a.beginPixelLocalStorageWEBGL(n.HEAPU32.subarray(c, c + b));
}, begin_texture_image_decode:function(a, b, c) {
  a = W[a];
  a.image = new Image();
  a.image.src = URL.createObjectURL(new Blob([n.HEAP8.subarray(b, b + c)]), {type:"image/png"});
  a.complete = !1;
}, emscripten_asm_const_int:(a, b, c) => {
  sd.length = 0;
  var d;
  for (c >>= 2; d = C[b++];) {
    c += 105 != d & c, sd.push(105 == d ? I[c] : ya[c++ >> 1]), ++c;
  }
  return Ua[a].apply(null, sd);
}, emscripten_date_now:function() {
  return Date.now();
}, emscripten_get_now:() => performance.now(), emscripten_memcpy_big:(a, b, c) => C.copyWithin(a, b, b + c), emscripten_resize_heap:a => {
  var b = C.length;
  a >>>= 0;
  if (2147483648 < a) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = b * (1 + 0.2 / c);
    d = Math.min(d, a + 100663296);
    var e = Math;
    d = Math.max(a, d);
    a: {
      e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - ua.buffer.byteLength + 65535 >>> 16;
      try {
        ua.grow(e);
        za();
        var f = 1;
        break a;
      } catch (g) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, emscripten_webgl_enable_extension:function(a, b) {
  a = r[a];
  b = b ? K(C, b) : "";
  b.startsWith("GL_") && (b = b.substr(3));
  "WEBGL_draw_instanced_base_vertex_base_instance" == b && td(Y);
  "WEBGL_multi_draw_instanced_base_vertex_base_instance" == b && ud(Y);
  "WEBGL_multi_draw" == b && Ed(Y);
  return !!a.H.getExtension(b);
}, emscripten_webgl_get_current_context:function() {
  return Dd ? Dd.handle : 0;
}, emscripten_webgl_make_context_current:function(a) {
  return ja(a) ? 0 : -5;
}, enable_WEBGL_provoking_vertex:function(a) {
  a = r[a].H;
  a.lb = a.getExtension("WEBGL_provoking_vertex");
  return !!a.lb;
}, enable_WEBGL_shader_pixel_local_storage_coherent:function(a) {
  a = r[a].H;
  a.ia = a.getExtension("WEBGL_shader_pixel_local_storage");
  return !(!a.ia || !a.ia.isCoherent());
}, endPixelLocalStorageWEBGL:function(a, b, c) {
  (a = r[a].H.ia) && a.endPixelLocalStorageWEBGL(n.HEAPU32.subarray(c, c + b));
}, environ_get:(a, b) => {
  var c = 0;
  Hd().forEach(function(d, e) {
    var f = b + c;
    e = J[a + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      A[e++ >> 0] = d.charCodeAt(f);
    }
    A[e >> 0] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(a, b) => {
  var c = Hd();
  J[a >> 2] = c.length;
  var d = 0;
  c.forEach(function(e) {
    d += e.length + 1;
  });
  J[b >> 2] = d;
  return 0;
}, fd_close:function(a) {
  try {
    var b = Jb(a);
    if (null === b.W) {
      throw new L(8);
    }
    b.Ma && (b.Ma = null);
    try {
      b.m.close && b.m.close(b);
    } catch (c) {
      throw c;
    } finally {
      wb[b.W] = null;
    }
    b.W = null;
    return 0;
  } catch (c) {
    if ("undefined" == typeof Wb || "ErrnoError" !== c.name) {
      throw c;
    }
    return c.$;
  }
}, fd_read:function(a, b, c, d) {
  try {
    a: {
      var e = Jb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var m = J[a >> 2], p = J[a + 4 >> 2];
        a += 8;
        var l = e, t = m, u = p, x = f, k = A;
        if (0 > u || 0 > x) {
          throw new L(28);
        }
        if (null === l.W) {
          throw new L(8);
        }
        if (1 === (l.flags & 2097155)) {
          throw new L(8);
        }
        if (16384 === (l.node.mode & 61440)) {
          throw new L(31);
        }
        if (!l.m.read) {
          throw new L(28);
        }
        var q = "undefined" != typeof x;
        if (!q) {
          x = l.position;
        } else if (!l.seekable) {
          throw new L(70);
        }
        var v = l.m.read(l, k, t, u, x);
        q || (l.position += v);
        var y = v;
        if (0 > y) {
          var B = -1;
          break a;
        }
        b += y;
        if (y < p) {
          break;
        }
        "undefined" !== typeof f && (f += y);
      }
      B = b;
    }
    J[d >> 2] = B;
    return 0;
  } catch (D) {
    if ("undefined" == typeof Wb || "ErrnoError" !== D.name) {
      throw D;
    }
    return D.$;
  }
}, fd_seek:function(a, b, c, d, e) {
  b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
  try {
    if (isNaN(b)) {
      return 61;
    }
    var f = Jb(a);
    Rb(f, b, d);
    Qa = [f.position >>> 0, (Pa = f.position, 1.0 <= +Math.abs(Pa) ? 0.0 < Pa ? +Math.floor(Pa / 4294967296.0) >>> 0 : ~~+Math.ceil((Pa - +(~~Pa >>> 0)) / 4294967296.0) >>> 0 : 0)];
    I[e >> 2] = Qa[0];
    I[e + 4 >> 2] = Qa[1];
    f.Ma && 0 === b && 0 === d && (f.Ma = null);
    return 0;
  } catch (g) {
    if ("undefined" == typeof Wb || "ErrnoError" !== g.name) {
      throw g;
    }
    return g.$;
  }
}, fd_write:function(a, b, c, d) {
  try {
    a: {
      var e = Jb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var m = J[a >> 2], p = J[a + 4 >> 2];
        a += 8;
        var l = e, t = m, u = p, x = f, k = A;
        if (0 > u || 0 > x) {
          throw new L(28);
        }
        if (null === l.W) {
          throw new L(8);
        }
        if (0 === (l.flags & 2097155)) {
          throw new L(8);
        }
        if (16384 === (l.node.mode & 61440)) {
          throw new L(31);
        }
        if (!l.m.write) {
          throw new L(28);
        }
        l.seekable && l.flags & 1024 && Rb(l, 0, 2);
        var q = "undefined" != typeof x;
        if (!q) {
          x = l.position;
        } else if (!l.seekable) {
          throw new L(70);
        }
        var v = l.m.write(l, k, t, u, x, void 0);
        q || (l.position += v);
        var y = v;
        if (0 > y) {
          var B = -1;
          break a;
        }
        b += y;
        "undefined" !== typeof f && (f += y);
      }
      B = b;
    }
    J[d >> 2] = B;
    return 0;
  } catch (D) {
    if ("undefined" == typeof Wb || "ErrnoError" !== D.name) {
      throw D;
    }
    return D.$;
  }
}, framebufferPixelLocalClearValuefvWEBGL:function(a, b, c, d, e, f) {
  (a = r[a].H.ia) && a.framebufferPixelLocalClearValuefvWEBGL(b, [c, d, e, f]);
}, framebufferTexturePixelLocalStorageWEBGL:function(a, b, c, d, e) {
  (a = r[a].H.ia) && a.framebufferTexturePixelLocalStorageWEBGL(b, W[c], d, e);
}, glActiveTexture:function(a) {
  Y.activeTexture(a);
}, glAttachShader:function(a, b) {
  Y.attachShader(V[a], zd[b]);
}, glBindBuffer:function(a, b) {
  35051 == a ? Y.Wa = b : 35052 == a && (Y.Ka = b);
  Y.bindBuffer(a, wd[b]);
}, glBindBufferRange:function(a, b, c, d, e) {
  Y.bindBufferRange(a, b, wd[c], d, e);
}, glBindFramebuffer:function(a, b) {
  Y.bindFramebuffer(a, xd[b]);
}, glBindRenderbuffer:function(a, b) {
  Y.bindRenderbuffer(a, yd[b]);
}, glBindTexture:function(a, b) {
  Y.bindTexture(a, W[b]);
}, glBindVertexArray:function(a) {
  Y.bindVertexArray(Ad[a]);
}, glBlendEquation:function(a) {
  Y.blendEquation(a);
}, glBlendFunc:function(a, b) {
  Y.blendFunc(a, b);
}, glBlitFramebuffer:function(a, b, c, d, e, f, g, m, p, l) {
  Y.blitFramebuffer(a, b, c, d, e, f, g, m, p, l);
}, glBufferData:function(a, b, c, d) {
  c && b ? Y.bufferData(a, C, d, c, b) : Y.bufferData(a, b, d);
}, glBufferSubData:function(a, b, c, d) {
  c && Y.bufferSubData(a, b, C, d, c);
}, glClear:function(a) {
  Y.clear(a);
}, glClearColor:function(a, b, c, d) {
  Y.clearColor(a, b, c, d);
}, glClearDepthf:function(a) {
  Y.clearDepth(a);
}, glClearStencil:function(a) {
  Y.clearStencil(a);
}, glColorMask:function(a, b, c, d) {
  Y.colorMask(!!a, !!b, !!c, !!d);
}, glCompileShader:function(a) {
  Y.compileShader(zd[a]);
}, glCreateProgram:function() {
  var a = ha(V), b = Y.createProgram();
  b.name = a;
  b.Fc = b.Dc = b.Ec = 0;
  b.Sa = 1;
  V[a] = b;
  return a;
}, glCreateShader:function(a) {
  var b = ha(zd);
  zd[b] = Y.createShader(a);
  return b;
}, glCullFace:function(a) {
  Y.cullFace(a);
}, glDeleteBuffers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2], e = wd[d];
    e && (Y.deleteBuffer(e), e.name = 0, wd[d] = null, d == Y.Wa && (Y.Wa = 0), d == Y.Ka && (Y.Ka = 0));
  }
}, glDeleteFramebuffers:function(a, b) {
  for (var c = 0; c < a; ++c) {
    var d = I[b + 4 * c >> 2], e = xd[d];
    e && (Y.deleteFramebuffer(e), e.name = 0, xd[d] = null);
  }
}, glDeleteProgram:function(a) {
  if (a) {
    var b = V[a];
    b ? (Y.deleteProgram(b), b.name = 0, V[a] = null) : X(1281);
  }
}, glDeleteRenderbuffers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2], e = yd[d];
    e && (Y.deleteRenderbuffer(e), e.name = 0, yd[d] = null);
  }
}, glDeleteShader:function(a) {
  if (a) {
    var b = zd[a];
    b ? (Y.deleteShader(b), zd[a] = null) : X(1281);
  }
}, glDeleteTextures:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2], e = W[d];
    e && (Y.deleteTexture(e), e.name = 0, W[d] = null);
  }
}, glDeleteVertexArrays:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2];
    Y.deleteVertexArray(Ad[d]);
    Ad[d] = null;
  }
}, glDepthFunc:function(a) {
  Y.depthFunc(a);
}, glDepthMask:function(a) {
  Y.depthMask(!!a);
}, glDepthRangef:function(a, b) {
  Y.depthRange(a, b);
}, glDisable:function(a) {
  Y.disable(a);
}, glDrawArrays:function(a, b, c) {
  Y.drawArrays(a, b, c);
}, glDrawArraysInstanced:function(a, b, c, d) {
  Y.drawArraysInstanced(a, b, c, d);
}, glDrawBuffers:function(a, b) {
  for (var c = Id[a], d = 0; d < a; d++) {
    c[d] = I[b + 4 * d >> 2];
  }
  Y.drawBuffers(c);
}, glDrawElements:function(a, b, c, d) {
  Y.drawElements(a, b, c, d);
}, glDrawElementsInstanced:function(a, b, c, d, e) {
  Y.drawElementsInstanced(a, b, c, d, e);
}, glEnable:function(a) {
  Y.enable(a);
}, glEnableVertexAttribArray:function(a) {
  Y.enableVertexAttribArray(a);
}, glFramebufferRenderbuffer:function(a, b, c, d) {
  Y.framebufferRenderbuffer(a, b, c, yd[d]);
}, glFramebufferTexture2D:function(a, b, c, d, e) {
  Y.framebufferTexture2D(a, b, c, W[d], e);
}, glFrontFace:function(a) {
  Y.frontFace(a);
}, glGenBuffers:function(a, b) {
  Jd(a, b, "createBuffer", wd);
}, glGenFramebuffers:function(a, b) {
  Jd(a, b, "createFramebuffer", xd);
}, glGenRenderbuffers:function(a, b) {
  Jd(a, b, "createRenderbuffer", yd);
}, glGenTextures:function(a, b) {
  Jd(a, b, "createTexture", W);
}, glGenVertexArrays:function(a, b) {
  Jd(a, b, "createVertexArray", Ad);
}, glGenerateMipmap:function(a) {
  Y.generateMipmap(a);
}, glGetIntegerv:function(a, b) {
  Kd(a, b);
}, glGetString:function(a) {
  var b = Bd[a];
  if (!b) {
    switch(a) {
      case 7939:
        b = Y.getSupportedExtensions() || [];
        b = b.concat(b.map(function(d) {
          return "GL_" + d;
        }));
        b = Md(b.join(" "));
        break;
      case 7936:
      case 7937:
      case 37445:
      case 37446:
        (b = Y.getParameter(a)) || X(1280);
        b = b && Md(b);
        break;
      case 7938:
        b = Md("OpenGL ES 3.0 (" + Y.getParameter(7938) + ")");
        break;
      case 35724:
        b = Y.getParameter(35724);
        var c = b.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
        null !== c && (3 == c[1].length && (c[1] += "0"), b = "OpenGL ES GLSL ES " + c[1] + " (" + b + ")");
        b = Md(b);
        break;
      default:
        X(1280);
    }
    Bd[a] = b;
  }
  return b;
}, glGetUniformBlockIndex:function(a, b) {
  return Y.getUniformBlockIndex(V[a], b ? K(C, b) : "");
}, glGetUniformLocation:function(a, b) {
  b = b ? K(C, b) : "";
  if (a = V[a]) {
    var c = a, d = c.oa, e = c.tb, f;
    if (!d) {
      for (c.oa = d = {}, c.sb = {}, f = 0; f < Y.getProgramParameter(c, 35718); ++f) {
        var g = Y.getActiveUniform(c, f);
        var m = g.name;
        g = g.size;
        var p = Nd(m);
        p = 0 < p ? m.slice(0, p) : m;
        var l = c.Sa;
        c.Sa += g;
        e[p] = [g, l];
        for (m = 0; m < g; ++m) {
          d[l] = m, c.sb[l++] = p;
        }
      }
    }
    c = a.oa;
    d = 0;
    e = b;
    f = Nd(b);
    0 < f && (d = parseInt(b.slice(f + 1)) >>> 0, e = b.slice(0, f));
    if ((e = a.tb[e]) && d < e[0] && (d += e[1], c[d] = c[d] || Y.getUniformLocation(a, b))) {
      return d;
    }
  } else {
    X(1281);
  }
  return -1;
}, glInvalidateFramebuffer:function(a, b, c) {
  for (var d = Id[b], e = 0; e < b; e++) {
    d[e] = I[c + 4 * e >> 2];
  }
  Y.invalidateFramebuffer(a, d);
}, glLinkProgram:function(a) {
  a = V[a];
  Y.linkProgram(a);
  a.oa = 0;
  a.tb = {};
}, glPixelStorei:function(a, b) {
  Y.pixelStorei(a, b);
}, glRenderbufferStorageMultisample:function(a, b, c, d, e) {
  Y.renderbufferStorageMultisample(a, b, c, d, e);
}, glScissor:function(a, b, c, d) {
  Y.scissor(a, b, c, d);
}, glShaderSource:function(a, b, c, d) {
  for (var e = "", f = 0; f < b; ++f) {
    var g = d ? I[d + 4 * f >> 2] : -1, m = I[c + 4 * f >> 2];
    g = m ? K(C, m, 0 > g ? void 0 : g) : "";
    e += g;
  }
  Y.shaderSource(zd[a], e);
}, glStencilFunc:function(a, b, c) {
  Y.stencilFunc(a, b, c);
}, glStencilFuncSeparate:function(a, b, c, d) {
  Y.stencilFuncSeparate(a, b, c, d);
}, glStencilMask:function(a) {
  Y.stencilMask(a);
}, glStencilOp:function(a, b, c) {
  Y.stencilOp(a, b, c);
}, glStencilOpSeparate:function(a, b, c, d) {
  Y.stencilOpSeparate(a, b, c, d);
}, glTexParameteri:function(a, b, c) {
  Y.texParameteri(a, b, c);
}, glTexStorage2D:function(a, b, c, d, e) {
  Y.texStorage2D(a, b, c, d, e);
}, glTexSubImage2D:function(a, b, c, d, e, f, g, m, p) {
  if (Y.Ka) {
    Y.texSubImage2D(a, b, c, d, e, f, g, m, p);
  } else if (p) {
    var l = m - 5120;
    l = 0 == l ? A : 1 == l ? C : 2 == l ? G : 4 == l ? I : 6 == l ? xa : 5 == l || 28922 == l || 28520 == l || 30779 == l || 30782 == l ? J : wa;
    Y.texSubImage2D(a, b, c, d, e, f, g, m, l, p >> 31 - Math.clz32(l.BYTES_PER_ELEMENT));
  } else {
    Y.texSubImage2D(a, b, c, d, e, f, g, m, null);
  }
}, glUniform1i:function(a, b) {
  var c = Y, d = c.uniform1i;
  var e = Y.Eb;
  if (e) {
    var f = e.oa[a];
    "number" == typeof f && (e.oa[a] = f = Y.getUniformLocation(e, e.sb[a] + (0 < f ? "[" + f + "]" : "")));
    a = f;
  } else {
    X(1282), a = void 0;
  }
  d.call(c, a, b);
}, glUniformBlockBinding:function(a, b, c) {
  a = V[a];
  Y.uniformBlockBinding(a, b, c);
}, glUseProgram:function(a) {
  a = V[a];
  Y.useProgram(a);
  Y.Eb = a;
}, glVertexAttribDivisor:function(a, b) {
  Y.vertexAttribDivisor(a, b);
}, glVertexAttribIPointer:function(a, b, c, d, e) {
  Y.vertexAttribIPointer(a, b, c, d, e);
}, glVertexAttribPointer:function(a, b, c, d, e, f) {
  Y.vertexAttribPointer(a, b, c, !!d, e, f);
}, glViewport:function(a, b, c, d) {
  Y.viewport(a, b, c, d);
}, is_texture_image_done_decoding:function(a) {
  a = W[a];
  return a.complete || a.image.complete;
}, provokingVertexWEBGL:function(a, b) {
  (a = r[a].H.lb) && a.provokingVertexWEBGL(b);
}, set_decoded_tex_image_2d:function(a, b) {
  a = r[a].H;
  b = W[b];
  a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, b.image);
  b.imageWidth = b.image.width;
  b.imageHeight = b.image.height;
  b.complete = !0;
  delete b.image;
}, strftime_l:(a, b, c, d) => Rd(a, b, c, d), texture_image_height:function(a) {
  a = W[a];
  return a.imageHeight;
}, texture_image_width:function(a) {
  a = W[a];
  return a.imageWidth;
}, webgl_texSubImage2DWithOffset:function(a, b, c, d, e, f, g, m, p, l) {
  a = r[a].H;
  a.texSubImage2D(b, c, d, e, f, g, m, p, l);
}};
(function() {
  function a(c) {
    z = c = c.exports;
    ua = z.memory;
    za();
    Aa = z.__indirect_function_table;
    Ca.unshift(z.__wasm_call_ctors);
    Fa--;
    n.monitorRunDependencies && n.monitorRunDependencies(Fa);
    if (0 == Fa && (null !== Ga && (clearInterval(Ga), Ga = null), Ha)) {
      var d = Ha;
      Ha = null;
      d();
    }
    return c;
  }
  var b = {env:Wd, wasi_snapshot_preview1:Wd,};
  Fa++;
  n.monitorRunDependencies && n.monitorRunDependencies(Fa);
  if (n.instantiateWasm) {
    try {
      return n.instantiateWasm(b, a);
    } catch (c) {
      ra("Module.instantiateWasm callback failed with error: " + c), ba(c);
    }
  }
  Oa(b, function(c) {
    a(c.instance);
  }).catch(ba);
  return {};
})();
var oc = a => (oc = z.free)(a), Ld = a => (Ld = z.malloc)(a), Ra = n._ma_device__on_notification_unlocked = a => (Ra = n._ma_device__on_notification_unlocked = z.ma_device__on_notification_unlocked)(a);
n._ma_malloc_emscripten = (a, b) => (n._ma_malloc_emscripten = z.ma_malloc_emscripten)(a, b);
n._ma_free_emscripten = (a, b) => (n._ma_free_emscripten = z.ma_free_emscripten)(a, b);
var Sa = n._ma_device_process_pcm_frames_capture__webaudio = (a, b, c) => (Sa = n._ma_device_process_pcm_frames_capture__webaudio = z.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), Ta = n._ma_device_process_pcm_frames_playback__webaudio = (a, b, c) => (Ta = n._ma_device_process_pcm_frames_playback__webaudio = z.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), Vd = () => (Vd = z.__errno_location)(), nc = a => (nc = z.__getTypeName)(a);
n.__embind_initialize_bindings = () => (n.__embind_initialize_bindings = z._embind_initialize_bindings)();
n.dynCall_iiji = (a, b, c, d, e) => (n.dynCall_iiji = z.dynCall_iiji)(a, b, c, d, e);
n.dynCall_iiiji = (a, b, c, d, e, f) => (n.dynCall_iiiji = z.dynCall_iiiji)(a, b, c, d, e, f);
n.dynCall_iij = (a, b, c, d) => (n.dynCall_iij = z.dynCall_iij)(a, b, c, d);
n.dynCall_jii = (a, b, c) => (n.dynCall_jii = z.dynCall_jii)(a, b, c);
n.dynCall_jiji = (a, b, c, d, e) => (n.dynCall_jiji = z.dynCall_jiji)(a, b, c, d, e);
n.dynCall_viijii = (a, b, c, d, e, f, g) => (n.dynCall_viijii = z.dynCall_viijii)(a, b, c, d, e, f, g);
n.dynCall_iiiiij = (a, b, c, d, e, f, g) => (n.dynCall_iiiiij = z.dynCall_iiiiij)(a, b, c, d, e, f, g);
n.dynCall_iiiiijj = (a, b, c, d, e, f, g, m, p) => (n.dynCall_iiiiijj = z.dynCall_iiiiijj)(a, b, c, d, e, f, g, m, p);
n.dynCall_iiiiiijj = (a, b, c, d, e, f, g, m, p, l) => (n.dynCall_iiiiiijj = z.dynCall_iiiiiijj)(a, b, c, d, e, f, g, m, p, l);
n.___start_em_js = 482596;
n.___stop_em_js = 485221;
var Xd;
Ha = function Yd() {
  Xd || Zd();
  Xd || (Ha = Yd);
};
function Zd() {
  function a() {
    if (!Xd && (Xd = !0, n.calledRun = !0, !va)) {
      n.noFSInit || Tb || (Tb = !0, Sb(), n.stdin = n.stdin, n.stdout = n.stdout, n.stderr = n.stderr, n.stdin ? Vb("stdin", n.stdin) : Ob("/dev/tty", "/dev/stdin"), n.stdout ? Vb("stdout", null, n.stdout) : Ob("/dev/tty", "/dev/stdout"), n.stderr ? Vb("stderr", null, n.stderr) : Ob("/dev/tty1", "/dev/stderr"), Qb("/dev/stdin", 0), Qb("/dev/stdout", 1), Qb("/dev/stderr", 1));
      zb = !1;
      Va(Ca);
      aa(n);
      if (n.onRuntimeInitialized) {
        n.onRuntimeInitialized();
      }
      if (n.postRun) {
        for ("function" == typeof n.postRun && (n.postRun = [n.postRun]); n.postRun.length;) {
          var b = n.postRun.shift();
          Da.unshift(b);
        }
      }
      Va(Da);
    }
  }
  if (!(0 < Fa)) {
    if (n.preRun) {
      for ("function" == typeof n.preRun && (n.preRun = [n.preRun]); n.preRun.length;) {
        Ea();
      }
    }
    Va(Ba);
    0 < Fa || (n.setStatus ? (n.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        n.setStatus("");
      }, 1);
      a();
    }, 1)) : a());
  }
}
if (n.preInit) {
  for ("function" == typeof n.preInit && (n.preInit = [n.preInit]); 0 < n.preInit.length;) {
    n.preInit.pop()();
  }
}
Zd();



  return moduleArg.ready
}

);
})();
export default Rive;